import type { NamespaceCatalog } from '@/i18n/ns';

const workspaceKnowledgeRuntimeCopy = {
  en: {
    justNow: 'just now',
    editedBy: 'edited by {name}',
    imported: 'imported',
    acceptedBy: 'accepted by {name}',
    acceptedPoneva: 'Accepted Poneva’s suggestion',
    acceptedFrom: 'Accepted a suggestion from {name}',
    acceptedNamed: 'Accepted {name}’s suggestion',
    acceptedSuggestion: 'Accepted a suggestion',
    fromMeeting: 'From the meeting',
    inYourChat: 'In your chat',
    inNamedChat: 'In {name}’s chat',
    inAChat: 'In a chat',
    connectedAgent: 'A connected agent',
    connectedAgentFor: 'Connected agent for {name}',
    repositoryImport: 'Repository import',
    importedText: 'Imported text',
    you: 'You',
    colleague: 'A colleague',
    editedPage: 'Edited the page',
    suggestedNewPage: 'Suggested a new page',
    suggestedMove: 'Suggested a move',
    suggestedArchive: 'Suggested archiving',
    saved: 'Saved',
    noTextYet: 'No text yet',
    openSuggestion: 'one:open suggestion|other:open suggestions',
    suggestion: 'one:suggestion|other:suggestions',
    archivedPage: 'one:archived page|other:archived pages',
    character: 'one:character|other:characters',
    runQueued: 'Waiting to start',
    runRunning: 'Still running',
    runApproval: 'Waiting for an approval in this chat',
    runCancelled: 'Stopped before it finished',
    runFinished: 'Finished.',
    runSavedResult: 'Saved a Result.',
    runCouldNotRead: 'Couldn’t read: {sources}.',
    runScheduled: 'Scheduled',
    runBy: 'Run by {name}',
    testRunBy: 'Test run by {name}',
    formerMember: 'a former member',
    youLower: 'you',
    colleagueLower: 'a colleague',
    missedTime: 'time',
    missedTimes: 'times',
    runs: 'Runs',
    openRunChat: 'Open the run chat',
    watch: 'Watch',
    cancel: 'Cancel',
    noRuns: 'No runs yet.',
    skill: 'Skill',
    skillPublished: 'The agent always uses the Skill’s published version.',
    whenRuns: 'When it runs',
    day: 'Day',
    time: 'Time',
    cron: 'Cron expression',
    notPublished: '· not published',
    version: '· version {version}',
    today: 'today',
    tomorrow: 'tomorrow',
    yesterday: 'yesterday',
    on: 'on',
    at: 'at',
    underCredits: 'under 0.1 credits',
    credit: 'credit',
    credits: 'credits',
    took: 'Took {duration}{used}',
    andUsed: 'and used {credits}',
    versionLabel: 'Version {version}',
    draftRevision: 'The draft, revision {version}',
    following: 'following {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Queued',
    statusRunning: 'Running',
    statusApproval: 'Needs approval',
    statusDone: 'Done',
    statusFailed: 'Failed',
    statusCancelled: 'Cancelled',
    loadingWorkspace: 'Loading your workspace…',
    knowledgeErrorRevision_conflict: 'This page changed while you were working on it.',
    knowledgeErrorSuggestion_outdated:
      'The text this suggestion changes has been edited since. It can only be rejected or withdrawn now.',
    knowledgeErrorSuggestion_reason_required: 'Say in a few words why this change is right.',
    knowledgeErrorSuggestion_no_change: 'This would not change the page.',
    knowledgeErrorSuggestion_markdown_required: 'A suggested new page needs some text.',
    knowledgeErrorCompany_publish_required: 'Only company publishers can accept changes.',
    knowledgeErrorKnowledge_proposal_limit:
      'Your company already has 200 suggestions waiting for review. Review some before suggesting more.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'You already have 50 suggestions waiting for review. Wait until some are decided, or withdraw some, before suggesting more.',
    knowledgeErrorKnowledge_page_too_large:
      'A page is larger than 256 KB. Split it into smaller pages.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'A page has more than 2,000 headings. Split it into smaller pages.',
    knowledgeErrorKnowledge_page_limit:
      'Your company has reached the limit of 2,000 knowledge pages.',
    knowledgeErrorKnowledge_page_archived: 'This page is archived.',
    knowledgeErrorKnowledge_page_has_children: 'Move or archive the pages under this one first.',
    knowledgeErrorKnowledge_page_delete_children:
      'Restore or delete the pages under this one first.',
    knowledgeErrorKnowledge_page_not_archived: 'Only an archived page can be restored or deleted.',
    knowledgeErrorKnowledge_root_page: 'The company overview page cannot be moved or archived.',
    knowledgeErrorKnowledge_page_cycle: 'A page cannot move under itself or one of its own pages.',
    knowledgeErrorKnowledge_parent_not_found: 'That page is no longer available.',
    knowledgeErrorKnowledge_parent_archived: 'That page is archived. Choose another one.',
    knowledgeErrorKnowledge_page_not_found: 'This page is no longer available.',
    knowledgeErrorKnowledge_proposal_not_found: 'This suggestion is no longer available to you.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Only the person who suggested this can withdraw it.',
    knowledgeErrorProposal_not_pending: 'This suggestion has already been decided.',
    knowledgeErrorProposal_requester_removed:
      'The person who suggested this is no longer in this company, so it cannot be accepted.',
    knowledgeErrorPage_archived:
      'This page was archived. Accepting this suggestion brings it back; review it again first.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva could not accept this input. Check the fields and try again.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Knowledge pages are unavailable right now. Please try again.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva took too long to answer. Please try again.',
    agentErrorAgent_unpublished: 'Publish a version before running this agent.',
    agentErrorAgent_revision_conflict:
      'Someone else changed this agent. Reload it before saving again.',
    agentErrorAgent_run_queue_full:
      'This agent already has several runs waiting. Try again in a moment.',
    agentErrorPublished_skill_required: 'Choose a published Skill you can use.',
    agentErrorInvalid_schedule:
      'That schedule could not be read. Check the time or the cron expression.',
    agentErrorSchedule_too_frequent: 'An agent can run at most every 15 minutes.',
    agentErrorAgent_edit_access_exists: 'You can already edit this agent.',
    agentErrorAgent_forbidden: 'You cannot change this agent.',
    agentErrorAgent_has_no_owner:
      'Its owner left, so it belongs to the company and stays a company agent. Switch it off or archive it instead.',
    agentErrorAgent_not_found: 'This agent is no longer available to you.',
    agentErrorAgent_instructions_required: 'Give it instructions or pin a Skill first.',
    toolbarBulletedList: 'Bulleted list',
    toolbarNumberedList: 'Numbered list',
    toolbarWebLink: 'Web link',
    agentErrorGeneric: 'We could not complete this request.',
  },
  bg: {
    knowledgeErrorSuggestion_reason_required:
      'С няколко думи обяснете защо тази промяна е правилна.',
    knowledgeErrorSuggestion_no_change: 'Това няма да промени страницата.',
    knowledgeErrorSuggestion_markdown_required: 'За предложената нова страница е необходим текст.',
    knowledgeErrorCompany_publish_required: 'Само издатели от компанията могат да приемат промени.',
    knowledgeErrorKnowledge_proposal_limit:
      'Компанията ви вече има 200 предложения, които чакат преглед. Прегледайте някои от тях, преди да предложите още.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Вече имате 50 предложения, които чакат преглед. Изчакайте, докато някои бъдат решени, или оттеглете част от тях, преди да предложите още.',
    knowledgeErrorKnowledge_page_too_large:
      'Страницата е по-голяма от 256 KB. Разделете я на по-малки страници.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Страницата има повече от 2 000 заглавия. Разделете я на по-малки страници.',
    knowledgeErrorKnowledge_page_limit:
      'Компанията ви достигна ограничението от 2 000 страници със знания.',
    knowledgeErrorKnowledge_page_archived: 'Тази страница е архивирана.',
    knowledgeErrorKnowledge_page_has_children:
      'Първо преместете или архивирайте страниците под нея.',
    knowledgeErrorKnowledge_page_delete_children:
      'Първо възстановете или изтрийте страниците под нея.',
    knowledgeErrorKnowledge_page_not_archived:
      'Само архивирана страница може да бъде възстановена или изтрита.',
    knowledgeErrorKnowledge_root_page:
      'Обзорната страница на компанията не може да бъде премествана или архивирана.',
    knowledgeErrorKnowledge_page_cycle:
      'Страница не може да бъде преместена под себе си или под някоя от собствените си страници.',
    knowledgeErrorKnowledge_parent_not_found: 'Тази страница вече не е налична.',
    knowledgeErrorKnowledge_parent_archived: 'Тази страница е архивирана. Изберете друга.',
    knowledgeErrorKnowledge_page_not_found: 'Тази страница вече не е налична.',
    knowledgeErrorKnowledge_proposal_not_found: 'Това предложение вече не е достъпно за вас.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Само човекът, направил предложението, може да го оттегли.',
    knowledgeErrorProposal_not_pending: 'Това предложение вече е решено.',
    knowledgeErrorProposal_requester_removed:
      'Човекът, направил предложението, вече не е в тази компания, затова то не може да бъде прието.',
    knowledgeErrorPage_archived:
      'Тази страница е архивирана. Приемането на това предложение ще я възстанови; първо я прегледайте отново.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva не успя да приеме този въведен текст. Проверете полетата и опитайте отново.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Страниците със знания в момента не са достъпни. Опитайте отново.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva отговори твърде бавно. Опитайте отново.',
    agentErrorAgent_unpublished: 'Публикувайте версия, преди да стартирате този агент.',
    agentErrorAgent_revision_conflict:
      'Някой друг промени този агент. Презаредете го, преди да запазите отново.',
    agentErrorAgent_run_queue_full:
      'Този агент вече има няколко чакащи стартирания. Опитайте отново след малко.',
    agentErrorPublished_skill_required: 'Изберете публикувано умение, което можете да използвате.',
    agentErrorInvalid_schedule:
      'Този график не може да бъде прочетен. Проверете часа или cron израза.',
    agentErrorSchedule_too_frequent: 'Агентът може да се стартира най-много веднъж на 15 минути.',
    agentErrorAgent_edit_access_exists: 'Вече можете да редактирате този агент.',
    agentErrorAgent_forbidden: 'Не можете да променяте този агент.',
    agentErrorAgent_has_no_owner:
      'Собственикът му е напуснал, затова той принадлежи на компанията и остава фирмен агент. Вместо това го изключете или архивирайте.',
    agentErrorAgent_not_found: 'Този агент вече не е достъпен за вас.',
    agentErrorAgent_instructions_required: 'Добавете инструкции или закачете умение.',
    toolbarBulletedList: 'Списък с водещи символи',
    toolbarNumberedList: 'Номериран списък',
    toolbarWebLink: 'Уеб връзка',
    agentErrorGeneric: 'Не успяхме да изпълним тази заявка.',
    justNow: 'току-що',
    editedBy: 'редактирано от {name}',
    imported: 'импортирано',
    acceptedBy: 'прието от {name}',
    acceptedPoneva: 'Приета е препоръката на Poneva',
    acceptedFrom: 'Приета е препоръка от {name}',
    acceptedNamed: 'Приета е препоръката на {name}',
    acceptedSuggestion: 'Приета е препоръка',
    fromMeeting: 'От срещата',
    inYourChat: 'В твоя чат',
    inNamedChat: 'В чата на {name}',
    inAChat: 'В чат',
    connectedAgent: 'Свързан агент',
    connectedAgentFor: 'Свързан агент за {name}',
    repositoryImport: 'Импортиране на хранилище',
    importedText: 'Импортиран текст',
    you: 'Ти',
    colleague: 'Колега',
    editedPage: 'Редактирана страница',
    suggestedNewPage: 'Предложена е нова страница',
    suggestedMove: 'Предложено преместване',
    suggestedArchive: 'Предложено архивиране',
    saved: 'Запазено',
    noTextYet: 'Все още няма текст',
    openSuggestion: 'one:отворена препоръка|other:отворени препоръки',
    suggestion: 'one:препоръка|other:препоръки',
    archivedPage: 'one:архивирана страница|other:архивирани страници',
    character: 'one:знак|other:знака',
    runQueued: 'В очакване на стартиране',
    runRunning: 'Все още се изпълнява',
    runApproval: 'В очакване на одобрение в този чат',
    runCancelled: 'Спряно преди завършване',
    runFinished: 'Завършено.',
    runSavedResult: 'Запазен е резултат.',
    runCouldNotRead: 'Не успя да прочете: {sources}.',
    runScheduled: 'Планирано',
    runBy: 'Изпълнение от {name}',
    testRunBy: 'Тестово изпълнение от {name}',
    formerMember: 'бивш член',
    youLower: 'ти',
    colleagueLower: 'колега',
    missedTime: 'път',
    missedTimes: 'пъти',
    runs: 'Изпълнения',
    openRunChat: 'Отвори чата на изпълнението',
    watch: 'Преглед',
    cancel: 'Отказ',
    noRuns: 'Все още няма изпълнения.',
    skill: 'Умение',
    skillPublished: 'Агентът винаги използва публикуваната версия на умението.',
    whenRuns: 'Кога се изпълнява',
    day: 'Ден',
    time: 'Час',
    cron: 'Cron израз',
    notPublished: '· непубликувано',
    version: '· версия {version}',
    today: 'днес',
    tomorrow: 'утре',
    yesterday: 'вчера',
    on: 'на',
    at: 'в',
    underCredits: 'под 0,1 кредита',
    credit: 'кредит',
    credits: 'кредита',
    took: 'Отне {duration}{used}',
    andUsed: 'и използва {credits}',
    versionLabel: 'Версия {version}',
    draftRevision: 'Чернова, редакция {version}',
    following: 'след {skills}',
    timeSecond: 'сек',
    timeMinute: 'мин',
    timeHour: 'ч',
    statusQueued: 'На опашка',
    statusRunning: 'Изпълнява се',
    statusApproval: 'Изисква одобрение',
    statusDone: 'Готово',
    statusFailed: 'Неуспешно',
    statusCancelled: 'Отказано',
    loadingWorkspace: 'Работното ти пространство се зарежда…',
    knowledgeErrorRevision_conflict: 'Тази страница се промени, докато работеше по нея.',
    knowledgeErrorSuggestion_outdated:
      'Текстът, който тази препоръка променя, е редактиран оттогава. Сега тя може само да бъде отхвърлена или оттеглена.',
  },
  hr: {
    justNow: 'upravo sada',
    editedBy: 'uredio/la {name}',
    imported: 'uvezena stavka',
    acceptedBy: 'prihvatio/la {name}',
    acceptedPoneva: 'Prihvaćen Ponevin prijedlog',
    acceptedFrom: 'Prihvaćen prijedlog od korisnika {name}',
    acceptedNamed: 'Prihvaćen prijedlog korisnika {name}',
    acceptedSuggestion: 'Prihvaćen prijedlog',
    fromMeeting: 'Sa sastanka',
    inYourChat: 'U vašem chatu',
    inNamedChat: 'U chatu korisnika {name}',
    inAChat: 'U chatu',
    connectedAgent: 'Povezani agent',
    connectedAgentFor: 'Povezani agent za korisnika {name}',
    repositoryImport: 'Uvoz repozitorija',
    importedText: 'Uvezeni tekst',
    you: 'Vi',
    colleague: 'Kolega',
    editedPage: 'Uređena stranica',
    suggestedNewPage: 'Predložena nova stranica',
    suggestedMove: 'Predloženo premještanje',
    suggestedArchive: 'Predloženo arhiviranje',
    saved: 'Spremljeno',
    noTextYet: 'Još nema teksta',
    openSuggestion: 'one:otvoreni prijedlog|other:otvoreni prijedlozi',
    suggestion: 'one:prijedlog|other:prijedlozi',
    archivedPage: 'one:arhivirana stranica|other:arhivirane stranice',
    character: 'one:znak|other:znakova',
    runQueued: 'Čeka na pokretanje',
    runRunning: 'Još se izvodi',
    runApproval: 'Čeka odobrenje u ovom chatu',
    runCancelled: 'Zaustavljeno prije dovršetka',
    runFinished: 'Dovršeno.',
    runSavedResult: 'Rezultat je spremljen.',
    runCouldNotRead: 'Nije bilo moguće pročitati: {sources}.',
    runScheduled: 'Zakazano',
    runBy: 'Pokrenuo/la {name}',
    testRunBy: 'Testno pokretanje: {name}',
    formerMember: 'bivši član',
    youLower: 'vi',
    colleagueLower: 'kolega',
    missedTime: 'puta',
    missedTimes: 'puta',
    runs: 'Pokretanja',
    openRunChat: 'Otvori chat pokretanja',
    watch: 'Prati',
    cancel: 'Otkaži',
    noRuns: 'Još nema pokretanja.',
    skill: 'Vještina',
    skillPublished: 'Agent uvijek koristi objavljenu verziju vještine.',
    whenRuns: 'Kada se pokreće',
    day: 'Dan',
    time: 'Vrijeme',
    cron: 'Cron izraz',
    notPublished: '· nije objavljeno',
    version: '· verzija {version}',
    today: 'danas',
    tomorrow: 'sutra',
    yesterday: 'jučer',
    on: 'na',
    at: 'u',
    underCredits: 'manje od 0,1 kredita',
    credit: 'kredit',
    credits: 'kredita',
    took: 'Trajanje: {duration}{used}',
    andUsed: 'i potrošeno {credits}',
    versionLabel: 'Verzija {version}',
    draftRevision: 'Nacrt, revizija {version}',
    following: 'prateći {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'U redu čekanja',
    statusRunning: 'Izvodi se',
    statusApproval: 'Potrebno odobrenje',
    statusDone: 'Dovršeno',
    statusFailed: 'Neuspješno',
    statusCancelled: 'Otkazano',
    loadingWorkspace: 'Učitavanje vašeg radnog prostora…',
    knowledgeErrorRevision_conflict: 'Ova se stranica promijenila dok ste radili na njoj.',
    knowledgeErrorSuggestion_outdated:
      'Tekst koji ovaj prijedlog mijenja u međuvremenu je uređen. Sada ga možete samo odbiti ili povući.',
    knowledgeErrorSuggestion_reason_required:
      'U nekoliko riječi navedite zašto je ova promjena ispravna.',
    knowledgeErrorSuggestion_no_change: 'Ovim se stranica neće promijeniti.',
    knowledgeErrorSuggestion_markdown_required: 'Predložena nova stranica treba sadržavati tekst.',
    knowledgeErrorCompany_publish_required: 'Promjene mogu prihvatiti samo objavljivači tvrtke.',
    knowledgeErrorKnowledge_proposal_limit:
      'Vaša tvrtka već ima 200 prijedloga na čekanju za pregled. Pregledajte neke prije nego što predložite još njih.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Već imate 50 prijedloga na čekanju za pregled. Pričekajte da se o nekima odluči ili povucite neke prije nego što predložite još njih.',
    knowledgeErrorKnowledge_page_too_large:
      'Stranica je veća od 256 KB. Podijelite je na manje stranice.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Stranica ima više od 2.000 naslova. Podijelite je na manje stranice.',
    knowledgeErrorKnowledge_page_limit:
      'Vaša je tvrtka dosegla ograničenje od 2.000 stranica znanja.',
    knowledgeErrorKnowledge_page_archived: 'Ova je stranica arhivirana.',
    knowledgeErrorKnowledge_page_has_children:
      'Najprije premjestite ili arhivirajte stranice pod ovom stranicom.',
    knowledgeErrorKnowledge_page_delete_children:
      'Najprije vratite ili izbrišite stranice pod ovom stranicom.',
    knowledgeErrorKnowledge_page_not_archived:
      'Vratiti ili izbrisati možete samo arhiviranu stranicu.',
    knowledgeErrorKnowledge_root_page:
      'Preglednu stranicu tvrtke nije moguće premjestiti ni arhivirati.',
    knowledgeErrorKnowledge_page_cycle:
      'Stranicu nije moguće premjestiti pod samu sebe ili neku od njezinih stranica.',
    knowledgeErrorKnowledge_parent_not_found: 'Ta stranica više nije dostupna.',
    knowledgeErrorKnowledge_parent_archived: 'Ta je stranica arhivirana. Odaberite drugu.',
    knowledgeErrorKnowledge_page_not_found: 'Ova stranica više nije dostupna.',
    knowledgeErrorKnowledge_proposal_not_found: 'Ovaj vam prijedlog više nije dostupan.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Ovaj prijedlog može povući samo osoba koja ga je predložila.',
    knowledgeErrorProposal_not_pending: 'O ovom je prijedlogu već odlučeno.',
    knowledgeErrorProposal_requester_removed:
      'Osoba koja je predložila ovo više nije u ovoj tvrtki pa prijedlog nije moguće prihvatiti.',
    knowledgeErrorPage_archived:
      'Ova je stranica arhivirana. Prihvaćanjem ovog prijedloga stranica se vraća, stoga je najprije ponovno pregledajte.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva nije mogla prihvatiti ovaj unos. Provjerite polja i pokušajte ponovno.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Stranice znanja trenutačno nisu dostupne. Pokušajte ponovno.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva je predugo odgovarala. Pokušajte ponovno.',
    agentErrorAgent_unpublished: 'Objavite verziju prije pokretanja ovog agenta.',
    agentErrorAgent_revision_conflict:
      'Netko je drugi promijenio ovog agenta. Ponovno ga učitajte prije spremanja.',
    agentErrorAgent_run_queue_full:
      'Ovaj agent već ima nekoliko pokretanja na čekanju. Pokušajte ponovno za trenutak.',
    agentErrorPublished_skill_required: 'Odaberite objavljenu vještinu koju možete koristiti.',
    agentErrorInvalid_schedule:
      'Nije moguće pročitati taj raspored. Provjerite vrijeme ili cron izraz.',
    agentErrorSchedule_too_frequent: 'Agent se može pokretati najviše svakih 15 minuta.',
    agentErrorAgent_edit_access_exists: 'Već možete uređivati ovog agenta.',
    agentErrorAgent_forbidden: 'Ne možete mijenjati ovog agenta.',
    agentErrorAgent_has_no_owner:
      'Njegov je vlasnik napustio tvrtku pa on pripada tvrtki i ostaje agent tvrtke. Umjesto toga ga isključite ili arhivirajte.',
    agentErrorAgent_not_found: 'Ovaj vam agent više nije dostupan.',
    agentErrorAgent_instructions_required: 'Zadajte mu upute ili najprije prikvačite vještinu.',
    toolbarBulletedList: 'Popis s grafičkim oznakama',
    toolbarNumberedList: 'Numerirani popis',
    toolbarWebLink: 'Web-poveznica',
    agentErrorGeneric: 'Nije moguće dovršiti ovaj zahtjev.',
  },
  cs: {
    justNow: 'právě teď',
    editedBy: 'upravil/a {name}',
    imported: 'importováno',
    acceptedBy: 'přijal/a {name}',
    acceptedPoneva: 'Přijat návrh od Ponevy',
    acceptedFrom: 'Přijat návrh od {name}',
    acceptedNamed: 'Přijat návrh od {name}',
    acceptedSuggestion: 'Přijat návrh',
    fromMeeting: 'Z porady',
    inYourChat: 'Ve vašem chatu',
    inNamedChat: 'V chatu uživatele {name}',
    inAChat: 'V chatu',
    connectedAgent: 'Připojený agent',
    connectedAgentFor: 'Připojený agent pro {name}',
    repositoryImport: 'Import repozitáře',
    importedText: 'Importovaný text',
    you: 'Vy',
    colleague: 'Kolega',
    editedPage: 'Upravena stránka',
    suggestedNewPage: 'Navržena nová stránka',
    suggestedMove: 'Navržen přesun',
    suggestedArchive: 'Navržena archivace',
    saved: 'Uloženo',
    noTextYet: 'Zatím žádný text',
    openSuggestion: 'one:otevřený návrh|other:otevřené návrhy',
    suggestion: 'one:návrh|other:návrhy',
    archivedPage: 'one:archivovaná stránka|other:archivované stránky',
    character: 'one:znak|other:znaky',
    runQueued: 'Čeká na spuštění',
    runRunning: 'Stále probíhá',
    runApproval: 'Čeká na schválení v tomto chatu',
    runCancelled: 'Zastaveno před dokončením',
    runFinished: 'Dokončeno.',
    runSavedResult: 'Výsledek uložen.',
    runCouldNotRead: 'Nepodařilo se přečíst: {sources}.',
    runScheduled: 'Naplánováno',
    runBy: 'Spustil/a {name}',
    testRunBy: 'Testovací spuštění od {name}',
    formerMember: 'bývalý člen',
    youLower: 'vy',
    colleagueLower: 'kolega',
    missedTime: 'krát',
    missedTimes: 'krát',
    runs: 'Spuštění',
    openRunChat: 'Otevřít chat spuštění',
    watch: 'Sledovat',
    cancel: 'Zrušit',
    noRuns: 'Zatím žádná spuštění.',
    skill: 'Dovednost',
    skillPublished: 'Agent vždy používá publikovanou verzi dovednosti.',
    whenRuns: 'Kdy se spouští',
    day: 'Den',
    time: 'Čas',
    cron: 'Výraz cron',
    notPublished: '· není publikováno',
    version: '· verze {version}',
    today: 'dnes',
    tomorrow: 'zítra',
    yesterday: 'včera',
    on: 'dne',
    at: 'v',
    underCredits: 'méně než 0,1 kreditu',
    credit: 'kredit',
    credits: 'kredity',
    took: 'Trvalo {duration}{used}',
    andUsed: 'a využito {credits}',
    versionLabel: 'Verze {version}',
    draftRevision: 'Koncept, revize {version}',
    following: 'následující: {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Ve frontě',
    statusRunning: 'Probíhá',
    statusApproval: 'Vyžaduje schválení',
    statusDone: 'Hotovo',
    statusFailed: 'Selhalo',
    statusCancelled: 'Zrušeno',
    loadingWorkspace: 'Načítá se váš workspace…',
    knowledgeErrorRevision_conflict: 'Tato stránka se během vaší práce změnila.',
    knowledgeErrorSuggestion_outdated:
      'Text, který tento návrh mění, byl mezitím upraven. Nyní jej lze pouze odmítnout nebo stáhnout.',
    knowledgeErrorSuggestion_reason_required: 'Stručně uveďte, proč je tato změna správná.',
    knowledgeErrorSuggestion_no_change: 'Tato změna by stránku nezměnila.',
    knowledgeErrorSuggestion_markdown_required: 'Navrhovaná nová stránka potřebuje nějaký text.',
    knowledgeErrorCompany_publish_required: 'Změny mohou přijímat pouze firemní vydavatelé.',
    knowledgeErrorKnowledge_proposal_limit:
      'Vaše společnost už má 200 návrhů čekajících na kontrolu. Některé nejprve zkontrolujte, než navrhnete další.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Už máte 50 návrhů čekajících na kontrolu. Než navrhnete další, počkejte, až o některých bude rozhodnuto, nebo některé stáhněte.',
    knowledgeErrorKnowledge_page_too_large:
      'Stránka je větší než 256 KB. Rozdělte ji na menší stránky.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Stránka obsahuje více než 2 000 nadpisů. Rozdělte ji na menší stránky.',
    knowledgeErrorKnowledge_page_limit: 'Vaše společnost dosáhla limitu 2 000 stránek znalostí.',
    knowledgeErrorKnowledge_page_archived: 'Tato stránka je archivovaná.',
    knowledgeErrorKnowledge_page_has_children:
      'Nejprve přesuňte nebo archivujte stránky pod touto stránkou.',
    knowledgeErrorKnowledge_page_delete_children:
      'Nejprve obnovte nebo smažte stránky pod touto stránkou.',
    knowledgeErrorKnowledge_page_not_archived:
      'Obnovit nebo smazat lze pouze archivovanou stránku.',
    knowledgeErrorKnowledge_root_page:
      'Stránku s přehledem společnosti nelze přesunout ani archivovat.',
    knowledgeErrorKnowledge_page_cycle:
      'Stránku nelze přesunout pod sebe ani pod jednu z jejích vlastních stránek.',
    knowledgeErrorKnowledge_parent_not_found: 'Tato stránka už není dostupná.',
    knowledgeErrorKnowledge_parent_archived: 'Tato stránka je archivovaná. Vyberte jinou.',
    knowledgeErrorKnowledge_page_not_found: 'Tato stránka už není dostupná.',
    knowledgeErrorKnowledge_proposal_not_found: 'Tento návrh už pro vás není dostupný.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Tento návrh může stáhnout pouze osoba, která ho navrhla.',
    knowledgeErrorProposal_not_pending: 'O tomto návrhu už bylo rozhodnuto.',
    knowledgeErrorProposal_requester_removed:
      'Osoba, která tento návrh navrhla, už není v této společnosti, takže ho nelze přijmout.',
    knowledgeErrorPage_archived:
      'Tato stránka byla archivována. Přijetím tohoto návrhu ji obnovíte; nejprve návrh znovu zkontrolujte.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva tento obsah nemohl přijmout. Zkontrolujte pole a zkuste to znovu.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Stránky znalostí momentálně nejsou dostupné. Zkuste to znovu.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva odpovídala příliš dlouho. Zkuste to znovu.',
    agentErrorAgent_unpublished: 'Před spuštěním tohoto agenta publikujte jeho verzi.',
    agentErrorAgent_revision_conflict:
      'Tento agent mezitím změnil někdo jiný. Před dalším uložením ho znovu načtěte.',
    agentErrorAgent_run_queue_full:
      'Tento agent už má několik spuštění ve frontě. Zkuste to za chvíli.',
    agentErrorPublished_skill_required: 'Vyberte publikovanou dovednost, kterou můžete použít.',
    agentErrorInvalid_schedule:
      'Tento plán se nepodařilo načíst. Zkontrolujte čas nebo výraz cron.',
    agentErrorSchedule_too_frequent: 'Agent se může spouštět nejvýše jednou za 15 minut.',
    agentErrorAgent_edit_access_exists: 'Tohoto agenta už můžete upravovat.',
    agentErrorAgent_forbidden: 'Tohoto agenta nemůžete měnit.',
    agentErrorAgent_has_no_owner:
      'Jeho vlastník odešel, takže patří společnosti a zůstává firemním agentem. Místo toho ho vypněte nebo archivujte.',
    agentErrorAgent_not_found: 'Tento agent už pro vás není dostupný.',
    agentErrorAgent_instructions_required: 'Zadejte mu pokyny nebo nejprve připněte dovednost.',
    toolbarBulletedList: 'Seznam s odrážkami',
    toolbarNumberedList: 'Číslovaný seznam',
    toolbarWebLink: 'Webový odkaz',
    agentErrorGeneric: 'Tento požadavek se nepodařilo dokončit.',
  },
  da: {
    knowledgeErrorSuggestion_reason_required: 'Skriv med få ord, hvorfor denne ændring er rigtig.',
    knowledgeErrorSuggestion_no_change: 'Dette ændrer ikke siden.',
    knowledgeErrorSuggestion_markdown_required: 'En foreslået ny side skal indeholde tekst.',
    knowledgeErrorCompany_publish_required: 'Kun virksomhedsudgivere kan acceptere ændringer.',
    knowledgeErrorKnowledge_proposal_limit:
      'Din virksomhed har allerede 200 forslag, der venter på gennemgang. Gennemgå nogle, før du foreslår flere.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Du har allerede 50 forslag, der venter på gennemgang. Vent, til nogle er afgjort, eller træk nogle tilbage, før du foreslår flere.',
    knowledgeErrorKnowledge_page_too_large:
      'En side er større end 256 KB. Opdel den i mindre sider.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'En side har mere end 2.000 overskrifter. Opdel den i mindre sider.',
    knowledgeErrorKnowledge_page_limit: 'Din virksomhed har nået grænsen på 2.000 videnssider.',
    knowledgeErrorKnowledge_page_archived: 'Denne side er arkiveret.',
    knowledgeErrorKnowledge_page_has_children: 'Flyt eller arkivér først siderne under denne.',
    knowledgeErrorKnowledge_page_delete_children: 'Gendan eller slet først siderne under denne.',
    knowledgeErrorKnowledge_page_not_archived: 'Kun en arkiveret side kan gendannes eller slettes.',
    knowledgeErrorKnowledge_root_page:
      'Virksomhedens oversigtsside kan ikke flyttes eller arkiveres.',
    knowledgeErrorKnowledge_page_cycle:
      'En side kan ikke flyttes ind under sig selv eller en af sine egne sider.',
    knowledgeErrorKnowledge_parent_not_found: 'Siden er ikke længere tilgængelig.',
    knowledgeErrorKnowledge_parent_archived: 'Siden er arkiveret. Vælg en anden.',
    knowledgeErrorKnowledge_page_not_found: 'Denne side er ikke længere tilgængelig.',
    knowledgeErrorKnowledge_proposal_not_found:
      'Dette forslag er ikke længere tilgængeligt for dig.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Kun den person, der foreslog dette, kan trække det tilbage.',
    knowledgeErrorProposal_not_pending: 'Dette forslag er allerede afgjort.',
    knowledgeErrorProposal_requester_removed:
      'Den person, der foreslog dette, er ikke længere i denne virksomhed, så det kan ikke accepteres.',
    knowledgeErrorPage_archived:
      'Denne side blev arkiveret. Hvis du accepterer dette forslag, bliver den gendannet; gennemgå det igen først.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva kunne ikke acceptere dette input. Kontrollér felterne, og prøv igen.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Videnssider er ikke tilgængelige lige nu. Prøv igen.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva brugte for lang tid på at svare. Prøv igen.',
    agentErrorAgent_unpublished: 'Udgiv en version, før du kører denne agent.',
    agentErrorAgent_revision_conflict:
      'En anden har ændret denne agent. Genindlæs den, før du gemmer igen.',
    agentErrorAgent_run_queue_full:
      'Denne agent har allerede flere kørsler i kø. Prøv igen om et øjeblik.',
    agentErrorPublished_skill_required: 'Vælg en udgivet færdighed, du kan bruge.',
    agentErrorInvalid_schedule:
      'Denne tidsplan kunne ikke læses. Kontrollér tidspunktet eller cron-udtrykket.',
    agentErrorSchedule_too_frequent: 'En agent kan højst køre hvert 15. minut.',
    agentErrorAgent_edit_access_exists: 'Du kan allerede redigere denne agent.',
    agentErrorAgent_forbidden: 'Du kan ikke ændre denne agent.',
    agentErrorAgent_has_no_owner:
      'Dens ejer er stoppet, så den tilhører virksomheden og forbliver en virksomhedsagent. Slå den fra eller arkivér den i stedet.',
    agentErrorAgent_not_found: 'Denne agent er ikke længere tilgængelig for dig.',
    agentErrorAgent_instructions_required:
      'Giv den instruktioner, eller fastgør en færdighed først.',
    toolbarBulletedList: 'Punktopstillet liste',
    toolbarNumberedList: 'Nummereret liste',
    toolbarWebLink: 'Weblink',
    agentErrorGeneric: 'Vi kunne ikke gennemføre denne anmodning.',
    justNow: 'lige nu',
    editedBy: 'redigeret af {name}',
    imported: 'importeret',
    acceptedBy: 'accepteret af {name}',
    acceptedPoneva: 'Accepterede Ponevas forslag',
    acceptedFrom: 'Accepterede et forslag fra {name}',
    acceptedNamed: 'Accepterede {name}s forslag',
    acceptedSuggestion: 'Accepterede et forslag',
    fromMeeting: 'Fra mødet',
    inYourChat: 'I din chat',
    inNamedChat: 'I {name}s chat',
    inAChat: 'I en chat',
    connectedAgent: 'En tilsluttet agent',
    connectedAgentFor: 'Tilsluttet agent for {name}',
    repositoryImport: 'Import af repository',
    importedText: 'Importeret tekst',
    you: 'Dig',
    colleague: 'En kollega',
    editedPage: 'Redigerede siden',
    suggestedNewPage: 'Foreslog en ny side',
    suggestedMove: 'Foreslog en flytning',
    suggestedArchive: 'Foreslog arkivering',
    saved: 'Gemt',
    noTextYet: 'Ingen tekst endnu',
    openSuggestion: 'one:åbent forslag|other:åbne forslag',
    suggestion: 'one:forslag|other:forslag',
    archivedPage: 'one:arkiveret side|other:arkiverede sider',
    character: 'one:tegn|other:tegn',
    runQueued: 'Venter på at starte',
    runRunning: 'Kører stadig',
    runApproval: 'Venter på en godkendelse i denne chat',
    runCancelled: 'Stoppet, før den blev færdig',
    runFinished: 'Færdig.',
    runSavedResult: 'Resultat gemt.',
    runCouldNotRead: 'Kunne ikke læse: {sources}.',
    runScheduled: 'Planlagt',
    runBy: 'Kørt af {name}',
    testRunBy: 'Testkørsel af {name}',
    formerMember: 'et tidligere medlem',
    youLower: 'dig',
    colleagueLower: 'en kollega',
    missedTime: 'gang',
    missedTimes: 'gange',
    runs: 'Kørsler',
    openRunChat: 'Åbn chatten for kørslen',
    watch: 'Se',
    cancel: 'Annuller',
    noRuns: 'Ingen kørsler endnu.',
    skill: 'Færdighed',
    skillPublished: 'Agenten bruger altid den publicerede version af færdigheden.',
    whenRuns: 'Når den kører',
    day: 'Dag',
    time: 'Tidspunkt',
    cron: 'Cron-udtryk',
    notPublished: '· ikke publiceret',
    version: '· version {version}',
    today: 'i dag',
    tomorrow: 'i morgen',
    yesterday: 'i går',
    on: 'den',
    at: 'kl.',
    underCredits: 'under 0,1 kreditter',
    credit: 'kredit',
    credits: 'kreditter',
    took: 'Tog {duration}{used}',
    andUsed: 'og brugte {credits}',
    versionLabel: 'Version {version}',
    draftRevision: 'Kladde, revision {version}',
    following: 'følger {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 't',
    statusQueued: 'I kø',
    statusRunning: 'Kører',
    statusApproval: 'Kræver godkendelse',
    statusDone: 'Færdig',
    statusFailed: 'Mislykkedes',
    statusCancelled: 'Annulleret',
    loadingWorkspace: 'Indlæser dit arbejdsområde…',
    knowledgeErrorRevision_conflict: 'Denne side blev ændret, mens du arbejdede på den.',
    knowledgeErrorSuggestion_outdated:
      'Den tekst, som dette forslag ændrer, er siden blevet redigeret. Det kan kun afvises eller trækkes tilbage nu.',
  },
  nl: {
    justNow: 'zojuist',
    editedBy: 'bewerkt door {name}',
    imported: 'geïmporteerd',
    acceptedBy: 'geaccepteerd door {name}',
    acceptedPoneva: 'Suggestie van Poneva geaccepteerd',
    acceptedFrom: 'Suggestie van {name} geaccepteerd',
    acceptedNamed: 'Suggestie van {name} geaccepteerd',
    acceptedSuggestion: 'Suggestie geaccepteerd',
    fromMeeting: 'Uit de vergadering',
    inYourChat: 'In je chat',
    inNamedChat: 'In de chat van {name}',
    inAChat: 'In een chat',
    connectedAgent: 'Verbonden agent',
    connectedAgentFor: 'Verbonden agent voor {name}',
    repositoryImport: 'Repository importeren',
    importedText: 'Geïmporteerde tekst',
    you: 'Jij',
    colleague: 'Een collega',
    editedPage: 'Pagina bewerkt',
    suggestedNewPage: 'Nieuwe pagina voorgesteld',
    suggestedMove: 'Verplaatsing voorgesteld',
    suggestedArchive: 'Archiveren voorgesteld',
    saved: 'Opgeslagen',
    noTextYet: 'Nog geen tekst',
    openSuggestion: 'one:suggestie openen|other:suggesties openen',
    suggestion: 'one:suggestie|other:suggesties',
    archivedPage: "one:gearchiveerde pagina|other:gearchiveerde pagina's",
    character: 'one:teken|other:tekens',
    runQueued: 'Wachten om te starten',
    runRunning: 'Nog steeds bezig',
    runApproval: 'Wachten op goedkeuring in deze chat',
    runCancelled: 'Gestopt voordat het was voltooid',
    runFinished: 'Voltooid.',
    runSavedResult: 'Resultaat opgeslagen.',
    runCouldNotRead: 'Lezen mislukt: {sources}.',
    runScheduled: 'Gepland',
    runBy: 'Uitgevoerd door {name}',
    testRunBy: 'Testuitvoering door {name}',
    formerMember: 'een voormalig lid',
    youLower: 'je',
    colleagueLower: 'een collega',
    missedTime: 'keer',
    missedTimes: 'keer',
    runs: 'Uitvoeringen',
    openRunChat: 'Uitvoeringschat openen',
    watch: 'Bekijken',
    cancel: 'Annuleren',
    noRuns: 'Nog geen uitvoeringen.',
    skill: 'Vaardigheid',
    skillPublished: 'De agent gebruikt altijd de gepubliceerde versie van de vaardigheid.',
    whenRuns: 'Wanneer het wordt uitgevoerd',
    day: 'Dag',
    time: 'Tijd',
    cron: 'Cron-expressie',
    notPublished: '· niet gepubliceerd',
    version: '· versie {version}',
    today: 'vandaag',
    tomorrow: 'morgen',
    yesterday: 'gisteren',
    on: 'op',
    at: 'om',
    underCredits: 'minder dan 0,1 credits',
    credit: 'credit',
    credits: 'credits',
    took: 'Duurde {duration}{used}',
    versionLabel: 'Versie {version}',
    draftRevision: 'Concept, revisie {version}',
    following: 'volgende {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'u',
    statusQueued: 'In wachtrij',
    statusRunning: 'Wordt uitgevoerd',
    statusApproval: 'Goedkeuring vereist',
    statusDone: 'Voltooid',
    statusFailed: 'Mislukt',
    statusCancelled: 'Geannuleerd',
    loadingWorkspace: 'Je werkruimte wordt geladen…',
    knowledgeErrorRevision_conflict: 'Deze pagina is gewijzigd terwijl je eraan werkte.',
    knowledgeErrorSuggestion_outdated:
      'De tekst die deze suggestie wijzigt, is sindsdien bewerkt. De suggestie kan nu alleen nog worden afgewezen of ingetrokken.',
    andUsed: 'en {credits} gebruikt',
    knowledgeErrorSuggestion_reason_required:
      'Leg in enkele woorden uit waarom deze wijziging juist is.',
    knowledgeErrorSuggestion_no_change: 'Hierdoor verandert de pagina niet.',
    knowledgeErrorSuggestion_markdown_required: 'Een voorgestelde nieuwe pagina heeft tekst nodig.',
    knowledgeErrorCompany_publish_required:
      'Alleen uitgevers van het bedrijf kunnen wijzigingen accepteren.',
    knowledgeErrorKnowledge_proposal_limit:
      'Je bedrijf heeft al 200 suggesties die op beoordeling wachten. Beoordeel er eerst enkele voordat je meer suggesties doet.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Je hebt al 50 suggesties die op beoordeling wachten. Wacht totdat er enkele zijn beoordeeld of trek er enkele in voordat je meer suggesties doet.',
    knowledgeErrorKnowledge_page_too_large:
      "Een pagina is groter dan 256 KB. Verdeel de inhoud over kleinere pagina's.",
    knowledgeErrorKnowledge_page_too_many_sections:
      "Een pagina heeft meer dan 2.000 koppen. Verdeel de inhoud over kleinere pagina's.",
    knowledgeErrorKnowledge_page_limit:
      "Je bedrijf heeft de limiet van 2.000 kennispagina's bereikt.",
    knowledgeErrorKnowledge_page_archived: 'Deze pagina is gearchiveerd.',
    knowledgeErrorKnowledge_page_has_children: "Verplaats of archiveer eerst de pagina's eronder.",
    knowledgeErrorKnowledge_page_delete_children: "Herstel of verwijder eerst de pagina's eronder.",
    knowledgeErrorKnowledge_page_not_archived:
      'Alleen een gearchiveerde pagina kan worden hersteld of verwijderd.',
    knowledgeErrorKnowledge_root_page:
      'De bedrijfsoverzichtspagina kan niet worden verplaatst of gearchiveerd.',
    knowledgeErrorKnowledge_page_cycle:
      "Een pagina kan niet onder zichzelf of een van de eigen pagina's worden geplaatst.",
    knowledgeErrorKnowledge_parent_not_found: 'Die pagina is niet meer beschikbaar.',
    knowledgeErrorKnowledge_parent_archived: 'Die pagina is gearchiveerd. Kies een andere pagina.',
    knowledgeErrorKnowledge_page_not_found: 'Deze pagina is niet meer beschikbaar.',
    knowledgeErrorKnowledge_proposal_not_found: 'Deze suggestie is niet meer beschikbaar voor jou.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Alleen degene die deze suggestie heeft gedaan, kan deze intrekken.',
    knowledgeErrorProposal_not_pending: 'Over deze suggestie is al een beslissing genomen.',
    knowledgeErrorProposal_requester_removed:
      'Degene die deze suggestie heeft gedaan, maakt geen deel meer uit van dit bedrijf. Daarom kan de suggestie niet worden geaccepteerd.',
    knowledgeErrorPage_archived:
      'Deze pagina is gearchiveerd. Als je deze suggestie accepteert, wordt de pagina teruggezet. Beoordeel de suggestie eerst opnieuw.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva kon deze invoer niet accepteren. Controleer de velden en probeer het opnieuw.',
    knowledgeErrorKnowledge_pages_unavailable:
      "Kennispagina's zijn momenteel niet beschikbaar. Probeer het opnieuw.",
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva deed er te lang over om te antwoorden. Probeer het opnieuw.',
    agentErrorAgent_unpublished: 'Publiceer een versie voordat je deze agent uitvoert.',
    agentErrorAgent_revision_conflict:
      'Iemand anders heeft deze agent gewijzigd. Laad de agent opnieuw voordat je hem weer opslaat.',
    agentErrorAgent_run_queue_full:
      'Voor deze agent staan al meerdere uitvoeringen in de wachtrij. Probeer het over enkele ogenblikken opnieuw.',
    agentErrorPublished_skill_required: 'Kies een gepubliceerde Vaardigheid die je kunt gebruiken.',
    agentErrorInvalid_schedule:
      'Dat schema kon niet worden gelezen. Controleer de tijd of de cron-expressie.',
    agentErrorSchedule_too_frequent: 'Een agent kan maximaal elke 15 minuten worden uitgevoerd.',
    agentErrorAgent_edit_access_exists: 'Je kunt deze agent al bewerken.',
    agentErrorAgent_forbidden: 'Je kunt deze agent niet wijzigen.',
    agentErrorAgent_has_no_owner:
      'De eigenaar is vertrokken. Daarom is deze agent eigendom van het bedrijf en blijft hij een bedrijfsagent. Schakel hem in plaats daarvan uit of archiveer hem.',
    agentErrorAgent_not_found: 'Deze agent is niet meer beschikbaar voor jou.',
    agentErrorAgent_instructions_required:
      'Geef de agent instructies of zet eerst een Vaardigheid vast.',
    toolbarBulletedList: 'Lijst met opsommingstekens',
    toolbarNumberedList: 'Genummerde lijst',
    toolbarWebLink: 'Weblink',
    agentErrorGeneric: 'We konden dit verzoek niet voltooien.',
  },
  et: {
    justNow: 'just nüüd',
    editedBy: 'muutis {name}',
    imported: 'imporditud',
    acceptedBy: 'võttis vastu {name}',
    acceptedPoneva: 'Võttis Poneva soovituse vastu',
    acceptedFrom: 'Võttis vastu kasutaja {name} soovituse',
    acceptedNamed: 'Võttis vastu kasutaja {name} soovituse',
    acceptedSuggestion: 'Võttis soovituse vastu',
    fromMeeting: 'Koosolekult',
    inYourChat: 'Sinu vestluses',
    inNamedChat: 'Kasutaja {name} vestluses',
    inAChat: 'Vestluses',
    connectedAgent: 'Ühendatud agent',
    connectedAgentFor: 'Kasutaja {name} ühendatud agent',
    repositoryImport: 'Hoidla import',
    importedText: 'Imporditud tekst',
    you: 'Sina',
    colleague: 'Kolleeg',
    editedPage: 'Muutis lehte',
    suggestedNewPage: 'Soovitas uut lehte',
    suggestedMove: 'Soovitas teisaldamist',
    suggestedArchive: 'Soovitas arhiveerimist',
    saved: 'Salvestatud',
    noTextYet: 'Tekst puudub',
    openSuggestion: 'one:ava soovitus|other:ava soovitused',
    suggestion: 'one:soovitus|other:soovitused',
    archivedPage: 'one:arhiveeritud leht|other:arhiveeritud lehed',
    character: 'one:märk|other:märgid',
    runQueued: 'Käivitamine on ootel',
    runRunning: 'Veel käib',
    runApproval: 'Ootab selles vestluses kinnitamist',
    runCancelled: 'Peatati enne lõpetamist',
    runFinished: 'Lõpetatud.',
    runSavedResult: 'Tulemus salvestatud.',
    runCouldNotRead: 'Ei õnnestunud lugeda: {sources}.',
    runScheduled: 'Ajastatud',
    runBy: 'Käivitas {name}',
    testRunBy: 'Testkäivituse tegi {name}',
    formerMember: 'endine liige',
    youLower: 'sina',
    colleagueLower: 'kolleeg',
    missedTime: 'korda',
    missedTimes: 'korda',
    runs: 'Käivitused',
    openRunChat: 'Ava käivituse vestlus',
    watch: 'Vaata',
    cancel: 'Tühista',
    noRuns: 'Käivitusi pole veel.',
    skill: 'Oskus',
    skillPublished: 'Agent kasutab alati oskuse avaldatud versiooni.',
    whenRuns: 'Käivitusaeg',
    day: 'Päev',
    time: 'Kellaaeg',
    cron: 'Cron-avaldise',
    notPublished: '· avaldamata',
    version: '· versioon {version}',
    today: 'täna',
    tomorrow: 'homme',
    yesterday: 'eile',
    on: 'kuupäeval',
    at: 'kell',
    underCredits: 'alla 0,1 krediidi',
    credit: 'krediit',
    credits: 'krediiti',
    took: 'Kulus {duration}{used}',
    andUsed: 'ja kasutas {credits}',
    versionLabel: 'Versioon {version}',
    draftRevision: 'Mustand, redaktsioon {version}',
    following: 'järgides {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Ootel',
    statusRunning: 'Käib',
    statusApproval: 'Vajab kinnitamist',
    statusDone: 'Valmis',
    statusFailed: 'Ebaõnnestus',
    statusCancelled: 'Tühistatud',
    loadingWorkspace: 'Sinu tööruumi laadimine…',
    knowledgeErrorRevision_conflict: 'See leht muutus selle töötlemise ajal.',
    knowledgeErrorSuggestion_outdated:
      'Selle soovituse muudetud teksti on pärast redigeeritud. Nüüd saab selle ainult tagasi lükata või tagasi võtta.',
    knowledgeErrorSuggestion_reason_required: 'Selgitage lühidalt, miks see muudatus on õige.',
    knowledgeErrorSuggestion_no_change: 'See ei muudaks lehte.',
    knowledgeErrorSuggestion_markdown_required: 'Soovitatud uus leht vajab teksti.',
    knowledgeErrorCompany_publish_required:
      'Muudatusi saavad vastu võtta ainult ettevõtte avaldajad.',
    knowledgeErrorKnowledge_proposal_limit:
      'Teie ettevõttel on juba 200 ülevaatamist ootavat soovitust. Enne uute soovitamist vaadake mõned neist üle.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Teil on juba 50 ülevaatamist ootavat soovitust. Oodake, kuni mõned neist otsustatakse, või võtke mõned tagasi, enne kui uusi soovitate.',
    knowledgeErrorKnowledge_page_too_large:
      'Leht on suurem kui 256 KB. Jagage see väiksemateks lehtedeks.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Lehel on üle 2000 pealkirja. Jagage see väiksemateks lehtedeks.',
    knowledgeErrorKnowledge_page_limit: 'Teie ettevõte on jõudnud 2000 teadmistelehe piirini.',
    knowledgeErrorKnowledge_page_archived: 'See leht on arhiveeritud.',
    knowledgeErrorKnowledge_page_has_children:
      'Teisaldage või arhiveerige esmalt selle all olevad lehed.',
    knowledgeErrorKnowledge_page_delete_children:
      'Taastage või kustutage esmalt selle all olevad lehed.',
    knowledgeErrorKnowledge_page_not_archived:
      'Taastada või kustutada saab ainult arhiveeritud lehte.',
    knowledgeErrorKnowledge_root_page: 'Ettevõtte ülevaatelehte ei saa teisaldada ega arhiveerida.',
    knowledgeErrorKnowledge_page_cycle:
      'Lehte ei saa teisaldada iseenda ega ühe oma alamlehe alla.',
    knowledgeErrorKnowledge_parent_not_found: 'See leht pole enam saadaval.',
    knowledgeErrorKnowledge_parent_archived: 'See leht on arhiveeritud. Valige mõni teine.',
    knowledgeErrorKnowledge_page_not_found: 'See leht pole enam saadaval.',
    knowledgeErrorKnowledge_proposal_not_found: 'See soovitus pole teile enam saadaval.',
    knowledgeErrorKnowledge_proposal_forbidden: 'Selle saab tagasi võtta ainult soovituse tegija.',
    knowledgeErrorProposal_not_pending: 'See soovitus on juba otsustatud.',
    knowledgeErrorProposal_requester_removed:
      'Selle soovituse tegija ei kuulu enam sellesse ettevõttesse, seega ei saa seda vastu võtta.',
    knowledgeErrorPage_archived:
      'See leht arhiveeriti. Selle soovituse vastuvõtmine taastab lehe; vaadake see esmalt uuesti üle.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva ei saanud seda sisendit vastu võtta. Kontrollige välju ja proovige uuesti.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Teadmistelehed pole praegu saadaval. Proovige uuesti.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva vastamine võttis liiga kaua aega. Proovige uuesti.',
    agentErrorAgent_unpublished: 'Enne selle agendi käivitamist avaldage versioon.',
    agentErrorAgent_revision_conflict:
      'Keegi teine muutis seda agenti. Enne uuesti salvestamist laadige see uuesti.',
    agentErrorAgent_run_queue_full:
      'Sellel agendil on juba mitu käivitamist ootel. Proovige hetke pärast uuesti.',
    agentErrorPublished_skill_required: 'Valige avaldatud oskus, mida saate kasutada.',
    agentErrorInvalid_schedule:
      'Seda ajakava ei saanud lugeda. Kontrollige kellaaega või cron-avaldist.',
    agentErrorSchedule_too_frequent: 'Agent saab käivituda kõige sagedamini iga 15 minuti järel.',
    agentErrorAgent_edit_access_exists: 'Teil on juba õigus seda agenti muuta.',
    agentErrorAgent_forbidden: 'Te ei saa seda agenti muuta.',
    agentErrorAgent_has_no_owner:
      'Selle omanik lahkus, seega kuulub agent ettevõttele ja jääb ettevõtte agendiks. Lülitage see välja või arhiveerige.',
    agentErrorAgent_not_found: 'See agent pole teile enam saadaval.',
    agentErrorAgent_instructions_required: 'Andke sellele juhised või kinnitage esmalt oskus.',
    toolbarBulletedList: 'Täpid',
    toolbarNumberedList: 'Nummerdatud loend',
    toolbarWebLink: 'Veebilink',
    agentErrorGeneric: 'Me ei saanud seda taotlust täita.',
  },
  fi: {
    justNow: 'juuri nyt',
    editedBy: 'muokannut {name}',
    imported: 'tuotu',
    acceptedBy: 'hyväksynyt {name}',
    acceptedPoneva: 'Hyväksyi Ponevan ehdotuksen',
    acceptedFrom: 'Hyväksyi ehdotuksen käyttäjältä {name}',
    acceptedNamed: 'Hyväksyi käyttäjän {name} ehdotuksen',
    acceptedSuggestion: 'Hyväksyi ehdotuksen',
    fromMeeting: 'Kokouksesta',
    inYourChat: 'Sinun chatissasi',
    inNamedChat: 'Käyttäjän {name} chatissa',
    inAChat: 'Chatissa',
    connectedAgent: 'Yhdistetty agentti',
    connectedAgentFor: 'Yhdistetty agentti käyttäjälle {name}',
    repositoryImport: 'Repositorioiden tuonti',
    importedText: 'Tuotu teksti',
    you: 'Sinä',
    colleague: 'Työtoveri',
    editedPage: 'Muokkasi sivua',
    suggestedNewPage: 'Ehdotti uutta sivua',
    suggestedMove: 'Ehdotti siirtoa',
    suggestedArchive: 'Ehdotti arkistointia',
    saved: 'Tallennettu',
    noTextYet: 'Ei tekstiä vielä',
    openSuggestion: 'one:avoin ehdotus|other:avoimia ehdotuksia',
    suggestion: 'one:ehdotus|other:ehdotuksia',
    archivedPage: 'one:arkistoitu sivu|other:arkistoituja sivuja',
    character: 'one:merkki|other:merkkiä',
    runQueued: 'Odottaa käynnistystä',
    runRunning: 'Suoritus on edelleen käynnissä',
    runApproval: 'Odottaa hyväksyntää tässä chatissa',
    runCancelled: 'Pysäytetty ennen valmistumista',
    runFinished: 'Valmis.',
    runSavedResult: 'Tulos tallennettu.',
    runCouldNotRead: 'Ei voitu lukea: {sources}.',
    runScheduled: 'Ajastettu',
    runBy: 'Suorittaja: {name}',
    testRunBy: 'Testisuorittaja: {name}',
    formerMember: 'entinen jäsen',
    youLower: 'sinä',
    colleagueLower: 'työtoveri',
    missedTime: 'kerran',
    missedTimes: 'kertaa',
    runs: 'Suoritukset',
    openRunChat: 'Avaa suorituschat',
    watch: 'Seuraa',
    cancel: 'Peruuta',
    noRuns: 'Ei suorituksia vielä.',
    skill: 'Taito',
    skillPublished: 'Agentti käyttää aina Taidon julkaistua versiota.',
    whenRuns: 'Suoritusajankohta',
    day: 'Päivä',
    time: 'Aika',
    cron: 'Cron-lauseke',
    notPublished: '· ei julkaistu',
    version: '· versio {version}',
    today: 'tänään',
    tomorrow: 'huomenna',
    yesterday: 'eilen',
    on: 'päivänä',
    at: 'klo',
    underCredits: 'alle 0,1 krediittiä',
    credit: 'krediitti',
    credits: 'krediittiä',
    took: 'Kesti {duration}{used}',
    andUsed: 'ja käytti {credits}',
    versionLabel: 'Versio {version}',
    draftRevision: 'Luonnos, versio {version}',
    following: 'seuraavat: {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Jonossa',
    statusRunning: 'Käynnissä',
    statusApproval: 'Hyväksyntä tarvitaan',
    statusDone: 'Valmis',
    statusFailed: 'Epäonnistui',
    statusCancelled: 'Peruutettu',
    loadingWorkspace: 'Ladataan työtilaasi…',
    knowledgeErrorRevision_conflict: 'Sivu muuttui, kun työskentelit sen parissa.',
    knowledgeErrorSuggestion_outdated:
      'Tekstiä, jota tämä ehdotus muuttaa, on muokattu sen jälkeen. Ehdotuksen voi nyt vain hylätä tai poistaa.',
    knowledgeErrorSuggestion_reason_required:
      'Kerro muutamalla sanalla, miksi tämä muutos on oikea.',
    knowledgeErrorSuggestion_no_change: 'Tämä ei muuttaisi sivua.',
    knowledgeErrorSuggestion_markdown_required: 'Ehdotettu uusi sivu tarvitsee tekstiä.',
    knowledgeErrorCompany_publish_required: 'Vain yrityksen julkaisijat voivat hyväksyä muutoksia.',
    knowledgeErrorKnowledge_proposal_limit:
      'Yritykselläsi on jo 200 tarkistamista odottavaa ehdotusta. Tarkista osa niistä ennen uusien ehdottamista.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Sinulla on jo 50 tarkistamista odottavaa ehdotusta. Odota, että osa niistä käsitellään, tai peruuta joitakin ennen uusien ehdottamista.',
    knowledgeErrorKnowledge_page_too_large:
      'Sivu on suurempi kuin 256 kt. Jaa se pienemmiksi sivuiksi.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Sivulla on yli 2 000 otsikkoa. Jaa se pienemmiksi sivuiksi.',
    knowledgeErrorKnowledge_page_limit: 'Yrityksesi 2 000 tietosivun enimmäismäärä on saavutettu.',
    knowledgeErrorKnowledge_page_archived: 'Tämä sivu on arkistoitu.',
    knowledgeErrorKnowledge_page_has_children: 'Siirrä tai arkistoi ensin tämän alla olevat sivut.',
    knowledgeErrorKnowledge_page_delete_children:
      'Palauta tai poista ensin tämän alla olevat sivut.',
    knowledgeErrorKnowledge_page_not_archived: 'Vain arkistoidun sivun voi palauttaa tai poistaa.',
    knowledgeErrorKnowledge_root_page: 'Yrityksen yleiskatsaussivua ei voi siirtää tai arkistoida.',
    knowledgeErrorKnowledge_page_cycle: 'Sivua ei voi siirtää itsensä tai omien alasivujensa alle.',
    knowledgeErrorKnowledge_parent_not_found: 'Sivu ei ole enää saatavilla.',
    knowledgeErrorKnowledge_parent_archived: 'Sivu on arkistoitu. Valitse toinen sivu.',
    knowledgeErrorKnowledge_page_not_found: 'Tämä sivu ei ole enää saatavilla.',
    knowledgeErrorKnowledge_proposal_not_found: 'Tämä ehdotus ei ole enää käytettävissäsi.',
    knowledgeErrorKnowledge_proposal_forbidden: 'Vain ehdotuksen tekijä voi perua sen.',
    knowledgeErrorProposal_not_pending: 'Tämä ehdotus on jo käsitelty.',
    knowledgeErrorProposal_requester_removed:
      'Ehdotuksen tekijä ei ole enää tässä yrityksessä, joten ehdotusta ei voi hyväksyä.',
    knowledgeErrorPage_archived:
      'Tämä sivu arkistoitiin. Ehdotuksen hyväksyminen palauttaa sen; tarkista ehdotus ensin uudelleen.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva ei voinut hyväksyä tätä syötettä. Tarkista kentät ja yritä uudelleen.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Tietosivut eivät ole juuri nyt käytettävissä. Yritä uudelleen.',
    knowledgeErrorKnowledge_pages_timeout: 'Ponevalla kesti liian kauan vastata. Yritä uudelleen.',
    agentErrorAgent_unpublished: 'Julkaise versio ennen tämän agentin suorittamista.',
    agentErrorAgent_revision_conflict:
      'Joku toinen muutti tätä agenttia. Lataa se uudelleen ennen uutta tallennusyritystä.',
    agentErrorAgent_run_queue_full:
      'Tällä agentilla on jo useita suorituksia jonossa. Yritä hetken kuluttua uudelleen.',
    agentErrorPublished_skill_required: 'Valitse julkaistu taito, jota voit käyttää.',
    agentErrorInvalid_schedule: 'Aikataulua ei voitu lukea. Tarkista aika tai cron-lauseke.',
    agentErrorSchedule_too_frequent: 'Agentti voi suorittaa toiminnon enintään 15 minuutin välein.',
    agentErrorAgent_edit_access_exists: 'Voit jo muokata tätä agenttia.',
    agentErrorAgent_forbidden: 'Et voi muuttaa tätä agenttia.',
    agentErrorAgent_has_no_owner:
      'Sen omistaja lähti, joten se kuuluu yritykselle ja pysyy yrityksen agenttina. Poista se käytöstä tai arkistoi se.',
    agentErrorAgent_not_found: 'Tämä agentti ei ole enää käytettävissäsi.',
    agentErrorAgent_instructions_required: 'Anna sille ohjeet tai kiinnitä taito ensin.',
    toolbarBulletedList: 'Luettelomerkein varustettu luettelo',
    toolbarNumberedList: 'Numeroitu luettelo',
    toolbarWebLink: 'Verkkolinkki',
    agentErrorGeneric: 'Tätä pyyntöä ei voitu suorittaa.',
  },
  fr: {
    knowledgeErrorSuggestion_reason_required:
      'Expliquez en quelques mots pourquoi cette modification est appropriée.',
    knowledgeErrorSuggestion_no_change: 'Cette modification ne changerait pas la page.',
    knowledgeErrorSuggestion_markdown_required:
      'Une nouvelle page proposée doit contenir du texte.',
    knowledgeErrorCompany_publish_required:
      'Seuls les éditeurs de l’entreprise peuvent accepter les modifications.',
    knowledgeErrorKnowledge_proposal_limit:
      'Votre entreprise a déjà 200 suggestions en attente d’examen. Examinez-en certaines avant d’en proposer d’autres.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Vous avez déjà 50 suggestions en attente d’examen. Attendez que certaines soient traitées ou retirez-en quelques-unes avant d’en proposer d’autres.',
    knowledgeErrorKnowledge_page_too_large:
      'Une page dépasse 256 Ko. Divisez-la en pages plus petites.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Une page comporte plus de 2 000 titres. Divisez-la en pages plus petites.',
    knowledgeErrorKnowledge_page_limit:
      'Votre entreprise a atteint la limite de 2 000 pages de connaissances.',
    knowledgeErrorKnowledge_page_archived: 'Cette page est archivée.',
    knowledgeErrorKnowledge_page_has_children:
      'Déplacez ou archivez d’abord les pages qu’elle contient.',
    knowledgeErrorKnowledge_page_delete_children:
      'Restaurez ou supprimez d’abord les pages qu’elle contient.',
    knowledgeErrorKnowledge_page_not_archived:
      'Seule une page archivée peut être restaurée ou supprimée.',
    knowledgeErrorKnowledge_root_page:
      'La page de présentation de l’entreprise ne peut pas être déplacée ni archivée.',
    knowledgeErrorKnowledge_page_cycle:
      'Une page ne peut pas être déplacée sous elle-même ou sous l’une de ses propres pages.',
    knowledgeErrorKnowledge_parent_not_found: 'Cette page n’est plus disponible.',
    knowledgeErrorKnowledge_parent_archived: 'Cette page est archivée. Choisissez-en une autre.',
    knowledgeErrorKnowledge_page_not_found: 'Cette page n’est plus disponible.',
    knowledgeErrorKnowledge_proposal_not_found: 'Cette suggestion ne vous est plus accessible.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Seule la personne à l’origine de cette suggestion peut la retirer.',
    knowledgeErrorProposal_not_pending: 'Cette suggestion a déjà été traitée.',
    knowledgeErrorProposal_requester_removed:
      'La personne à l’origine de cette suggestion ne fait plus partie de cette entreprise. Elle ne peut donc pas être acceptée.',
    knowledgeErrorPage_archived:
      'Cette page a été archivée. Accepter cette suggestion la restaurerait ; examinez-la à nouveau au préalable.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva n’a pas pu accepter ces informations. Vérifiez les champs et réessayez.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Les pages de connaissances sont momentanément indisponibles. Réessayez.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva a mis trop de temps à répondre. Réessayez.',
    agentErrorAgent_unpublished: 'Publiez une version avant d’exécuter cet agent.',
    agentErrorAgent_revision_conflict:
      'Quelqu’un a modifié cet agent. Rechargez-le avant de l’enregistrer à nouveau.',
    agentErrorAgent_run_queue_full:
      'Plusieurs exécutions de cet agent sont déjà en attente. Réessayez dans un instant.',
    agentErrorPublished_skill_required:
      'Choisissez une compétence publiée que vous pouvez utiliser.',
    agentErrorInvalid_schedule:
      'Cette planification n’a pas pu être lue. Vérifiez l’heure ou l’expression cron.',
    agentErrorSchedule_too_frequent: 'Un agent peut s’exécuter au maximum toutes les 15 minutes.',
    agentErrorAgent_edit_access_exists: 'Vous pouvez déjà modifier cet agent.',
    agentErrorAgent_forbidden: 'Vous ne pouvez pas modifier cet agent.',
    agentErrorAgent_has_no_owner:
      'Son propriétaire est parti. Il appartient donc à l’entreprise et reste un agent d’entreprise. Désactivez-le ou archivez-le à la place.',
    agentErrorAgent_not_found: 'Cet agent ne vous est plus accessible.',
    agentErrorAgent_instructions_required:
      'Donnez-lui des instructions ou épinglez d’abord une compétence.',
    toolbarBulletedList: 'Liste à puces',
    toolbarNumberedList: 'Liste numérotée',
    toolbarWebLink: 'Lien web',
    agentErrorGeneric: 'Nous n’avons pas pu traiter cette demande.',
    justNow: 'à l’instant',
    editedBy: 'modifié par {name}',
    imported: 'importé',
    acceptedBy: 'accepté par {name}',
    acceptedPoneva: 'Suggestion de Poneva acceptée',
    acceptedFrom: 'Suggestion acceptée de la part de {name}',
    acceptedNamed: 'Suggestion de {name} acceptée',
    acceptedSuggestion: 'Suggestion acceptée',
    fromMeeting: 'De la réunion',
    inYourChat: 'Dans votre chat',
    inNamedChat: 'Dans le chat de {name}',
    inAChat: 'Dans un chat',
    connectedAgent: 'Agent connecté',
    connectedAgentFor: 'Agent connecté pour {name}',
    repositoryImport: 'Importation du dépôt',
    importedText: 'Texte importé',
    you: 'Vous',
    colleague: 'Un collègue',
    editedPage: 'Page modifiée',
    suggestedNewPage: 'A suggéré une nouvelle page',
    suggestedMove: 'A suggéré un déplacement',
    suggestedArchive: 'A suggéré l’archivage',
    saved: 'Enregistré',
    noTextYet: 'Aucun texte pour le moment',
    openSuggestion: 'one:ouvrir la suggestion|other:ouvrir les suggestions',
    suggestion: 'one:suggestion|other:suggestions',
    archivedPage: 'one:page archivée|other:pages archivées',
    character: 'one:caractère|other:caractères',
    runQueued: 'En attente de démarrage',
    runRunning: 'Toujours en cours',
    runApproval: 'En attente d’une approbation dans ce chat',
    runCancelled: 'Arrêtée avant la fin',
    runFinished: 'Terminée.',
    runSavedResult: 'Résultat enregistré.',
    runCouldNotRead: 'Lecture impossible\u00a0: {sources}.',
    runScheduled: 'Planifiée',
    runBy: 'Exécution par {name}',
    testRunBy: 'Exécution de test par {name}',
    formerMember: 'un ancien membre',
    youLower: 'vous',
    colleagueLower: 'un collègue',
    missedTime: 'fois',
    missedTimes: 'fois',
    runs: 'Exécutions',
    openRunChat: 'Ouvrir le chat de l’exécution',
    watch: 'Suivre',
    cancel: 'Annuler',
    noRuns: 'Aucune exécution pour le moment.',
    skill: 'Compétence',
    skillPublished: 'L’agent utilise toujours la version publiée de la compétence.',
    whenRuns: 'Lors de son exécution',
    day: 'Jour',
    time: 'Heure',
    cron: 'Expression cron',
    notPublished: '· non publiée',
    version: '· version {version}',
    today: 'aujourd’hui',
    tomorrow: 'demain',
    yesterday: 'hier',
    on: 'le',
    at: 'à',
    underCredits: 'moins de 0,1 crédit',
    credit: 'crédit',
    credits: 'crédits',
    took: 'A duré {duration}{used}',
    andUsed: 'et a utilisé {credits}',
    versionLabel: 'Version {version}',
    draftRevision: 'Brouillon, révision {version}',
    following: 'suivant {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'En attente',
    statusRunning: 'En cours',
    statusApproval: 'Approbation requise',
    statusDone: 'Terminée',
    statusFailed: 'Échec',
    statusCancelled: 'Annulée',
    loadingWorkspace: 'Chargement de votre espace de travail…',
    knowledgeErrorRevision_conflict:
      'Cette page a été modifiée pendant que vous travailliez dessus.',
    knowledgeErrorSuggestion_outdated:
      'Le texte modifié par cette suggestion a été édité depuis. Elle ne peut désormais être que rejetée ou retirée.',
  },
  de: {
    knowledgeErrorSuggestion_reason_required:
      'Nenne in wenigen Worten, warum diese Änderung richtig ist.',
    knowledgeErrorSuggestion_no_change: 'Dadurch würde sich die Seite nicht ändern.',
    knowledgeErrorSuggestion_markdown_required: 'Eine vorgeschlagene neue Seite benötigt Text.',
    knowledgeErrorCompany_publish_required:
      'Nur Unternehmensveröffentlicher können Änderungen annehmen.',
    knowledgeErrorKnowledge_proposal_limit:
      'Ihr Unternehmen hat bereits 200 Vorschläge zur Überprüfung. Überprüfen Sie einige, bevor Sie weitere vorschlagen.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Sie haben bereits 50 Vorschläge zur Überprüfung. Warten Sie, bis einige entschieden wurden, oder ziehen Sie einige zurück, bevor Sie weitere vorschlagen.',
    knowledgeErrorKnowledge_page_too_large:
      'Eine Seite ist größer als 256 KB. Teilen Sie sie in kleinere Seiten auf.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Eine Seite enthält mehr als 2.000 Überschriften. Teilen Sie sie in kleinere Seiten auf.',
    knowledgeErrorKnowledge_page_limit:
      'Ihr Unternehmen hat das Limit von 2.000 Wissensseiten erreicht.',
    knowledgeErrorKnowledge_page_archived: 'Diese Seite ist archiviert.',
    knowledgeErrorKnowledge_page_has_children:
      'Verschieben oder archivieren Sie zuerst die darunterliegenden Seiten.',
    knowledgeErrorKnowledge_page_delete_children:
      'Stellen Sie zuerst die darunterliegenden Seiten wieder her oder löschen Sie sie.',
    knowledgeErrorKnowledge_page_not_archived:
      'Nur eine archivierte Seite kann wiederhergestellt oder gelöscht werden.',
    knowledgeErrorKnowledge_root_page:
      'Die Übersichtsseite des Unternehmens kann nicht verschoben oder archiviert werden.',
    knowledgeErrorKnowledge_page_cycle:
      'Eine Seite kann nicht unter sich selbst oder unter einer ihrer eigenen Seiten verschoben werden.',
    knowledgeErrorKnowledge_parent_not_found: 'Diese Seite ist nicht mehr verfügbar.',
    knowledgeErrorKnowledge_parent_archived:
      'Diese Seite ist archiviert. Wählen Sie eine andere aus.',
    knowledgeErrorKnowledge_page_not_found: 'Diese Seite ist nicht mehr verfügbar.',
    knowledgeErrorKnowledge_proposal_not_found:
      'Dieser Vorschlag ist für Sie nicht mehr verfügbar.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Nur die Person, die diesen Vorschlag gemacht hat, kann ihn zurückziehen.',
    knowledgeErrorProposal_not_pending: 'Dieser Vorschlag wurde bereits entschieden.',
    knowledgeErrorProposal_requester_removed:
      'Die Person, die diesen Vorschlag gemacht hat, ist nicht mehr in diesem Unternehmen. Daher kann er nicht angenommen werden.',
    knowledgeErrorPage_archived:
      'Diese Seite wurde archiviert. Wenn Sie diesen Vorschlag annehmen, wird sie wiederhergestellt. Überprüfen Sie ihn zuerst erneut.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva konnte diese Eingabe nicht annehmen. Überprüfen Sie die Felder und versuchen Sie es erneut.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Wissensseiten sind derzeit nicht verfügbar. Bitte versuchen Sie es erneut.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva hat zu lange für eine Antwort gebraucht. Bitte versuchen Sie es erneut.',
    agentErrorAgent_unpublished:
      'Veröffentlichen Sie zuerst eine Version, bevor Sie diesen Agenten ausführen.',
    agentErrorAgent_revision_conflict:
      'Jemand anderes hat diesen Agenten geändert. Laden Sie ihn neu, bevor Sie erneut speichern.',
    agentErrorAgent_run_queue_full:
      'Für diesen Agenten stehen bereits mehrere Ausführungen an. Versuchen Sie es gleich noch einmal.',
    agentErrorPublished_skill_required:
      'Wählen Sie eine veröffentlichte Fähigkeit aus, die Sie verwenden können.',
    agentErrorInvalid_schedule:
      'Dieser Zeitplan konnte nicht gelesen werden. Überprüfen Sie die Uhrzeit oder den Cron-Ausdruck.',
    agentErrorSchedule_too_frequent: 'Ein Agent kann höchstens alle 15 Minuten ausgeführt werden.',
    agentErrorAgent_edit_access_exists: 'Sie können diesen Agenten bereits bearbeiten.',
    agentErrorAgent_forbidden: 'Sie können diesen Agenten nicht ändern.',
    agentErrorAgent_has_no_owner:
      'Der Besitzer ist ausgeschieden. Daher gehört der Agent dem Unternehmen und bleibt ein Unternehmensagent. Schalten Sie ihn stattdessen aus oder archivieren Sie ihn.',
    agentErrorAgent_not_found: 'Dieser Agent ist für Sie nicht mehr verfügbar.',
    agentErrorAgent_instructions_required:
      'Geben Sie Anweisungen ein oder heften Sie zuerst eine Fähigkeit an.',
    toolbarBulletedList: 'Aufzählung',
    toolbarNumberedList: 'Nummerierte Liste',
    toolbarWebLink: 'Weblink',
    agentErrorGeneric: 'Wir konnten diese Anfrage nicht abschließen.',
    justNow: 'gerade eben',
    editedBy: 'bearbeitet von {name}',
    imported: 'importiert',
    acceptedBy: 'angenommen von {name}',
    acceptedPoneva: 'Ponevas Vorschlag angenommen',
    acceptedFrom: 'Vorschlag von {name} angenommen',
    acceptedNamed: 'Vorschlag von {name} angenommen',
    acceptedSuggestion: 'Vorschlag angenommen',
    fromMeeting: 'Aus dem Meeting',
    inYourChat: 'In Ihrem Chat',
    inNamedChat: 'Im Chat von {name}',
    inAChat: 'In einem Chat',
    connectedAgent: 'Verbundener Agent',
    connectedAgentFor: 'Verbundener Agent, {name} zugewiesen',
    repositoryImport: 'Repository-Import',
    importedText: 'Importierter Text',
    you: 'Sie',
    colleague: 'Ein Kollege',
    editedPage: 'Seite bearbeitet',
    suggestedNewPage: 'Neue Seite vorgeschlagen',
    suggestedMove: 'Verschieben vorgeschlagen',
    suggestedArchive: 'Archivieren vorgeschlagen',
    saved: 'Gespeichert',
    noTextYet: 'Noch kein Text',
    openSuggestion: 'one:offener Vorschlag|other:offene Vorschläge',
    suggestion: 'one:Vorschlag|other:Vorschläge',
    archivedPage: 'one:archivierte Seite|other:archivierte Seiten',
    character: 'one:Zeichen|other:Zeichen',
    runQueued: 'Wartet auf den Start',
    runRunning: 'Wird noch ausgeführt',
    runApproval: 'Wartet auf eine Genehmigung in diesem Chat',
    runCancelled: 'Vor Abschluss beendet',
    runFinished: 'Abgeschlossen.',
    runSavedResult: 'Ergebnis gespeichert.',
    runCouldNotRead: 'Lesen nicht möglich: {sources}.',
    runScheduled: 'Geplant',
    runBy: 'Ausgeführt von {name}',
    testRunBy: 'Testausführung von {name}',
    formerMember: 'ein ehemaliges Mitglied',
    youLower: 'Ihnen',
    colleagueLower: 'ein Kollege',
    missedTime: 'Mal',
    missedTimes: 'Mal',
    runs: 'Ausführungen',
    openRunChat: 'Ausführungschat öffnen',
    watch: 'Beobachten',
    cancel: 'Abbrechen',
    noRuns: 'Noch keine Ausführungen.',
    skill: 'Fähigkeit',
    skillPublished: 'Der Agent verwendet immer die veröffentlichte Version der Fähigkeit.',
    whenRuns: 'Wann es ausgeführt wird',
    day: 'Tag',
    time: 'Uhrzeit',
    cron: 'Cron-Ausdruck',
    notPublished: '· nicht veröffentlicht',
    version: '· Version {version}',
    today: 'heute',
    tomorrow: 'morgen',
    yesterday: 'gestern',
    on: 'am',
    at: 'um',
    underCredits: 'unter 0,1 Credits',
    credit: 'Credit',
    credits: 'Credits',
    took: 'Benötigte {duration}{used}',
    andUsed: 'und verbrauchte {credits}',
    versionLabel: 'Version {version}',
    draftRevision: 'Entwurf, Revision {version}',
    following: 'folgende {skills}',
    timeSecond: 's',
    timeMinute: 'Min.',
    timeHour: 'Std.',
    statusQueued: 'In Warteschlange',
    statusRunning: 'Wird ausgeführt',
    statusApproval: 'Genehmigung erforderlich',
    statusDone: 'Abgeschlossen',
    statusFailed: 'Fehlgeschlagen',
    statusCancelled: 'Abgebrochen',
    loadingWorkspace: 'Ihr Arbeitsbereich wird geladen…',
    knowledgeErrorRevision_conflict: 'Diese Seite wurde während Ihrer Bearbeitung geändert.',
    knowledgeErrorSuggestion_outdated:
      'Der von diesem Vorschlag geänderte Text wurde inzwischen bearbeitet. Er kann jetzt nur noch abgelehnt oder zurückgezogen werden.',
  },
  el: {
    knowledgeErrorSuggestion_reason_required:
      'Πείτε με λίγα λόγια γιατί είναι σωστή αυτή η αλλαγή.',
    knowledgeErrorSuggestion_no_change: 'Αυτό δεν θα αλλάξει τη σελίδα.',
    knowledgeErrorSuggestion_markdown_required: 'Μια προτεινόμενη νέα σελίδα χρειάζεται κείμενο.',
    knowledgeErrorCompany_publish_required:
      'Μόνο οι εκδότες της εταιρείας μπορούν να αποδέχονται αλλαγές.',
    knowledgeErrorKnowledge_proposal_limit:
      'Η εταιρεία σας έχει ήδη 200 προτάσεις σε αναμονή ελέγχου. Ελέγξτε κάποιες πριν προτείνετε άλλες.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Έχετε ήδη 50 προτάσεις σε αναμονή ελέγχου. Περιμένετε να ληφθεί απόφαση για κάποιες ή αποσύρετε κάποιες πριν προτείνετε άλλες.',
    knowledgeErrorKnowledge_page_too_large:
      'Μια σελίδα είναι μεγαλύτερη από 256 KB. Χωρίστε την σε μικρότερες σελίδες.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Μια σελίδα έχει περισσότερες από 2.000 επικεφαλίδες. Χωρίστε την σε μικρότερες σελίδες.',
    knowledgeErrorKnowledge_page_limit: 'Η εταιρεία σας έφτασε το όριο των 2.000 σελίδων γνώσης.',
    knowledgeErrorKnowledge_page_archived: 'Αυτή η σελίδα είναι αρχειοθετημένη.',
    knowledgeErrorKnowledge_page_has_children:
      'Μετακινήστε ή αρχειοθετήστε πρώτα τις σελίδες που βρίσκονται κάτω από αυτήν.',
    knowledgeErrorKnowledge_page_delete_children:
      'Επαναφέρετε ή διαγράψτε πρώτα τις σελίδες που βρίσκονται κάτω από αυτήν.',
    knowledgeErrorKnowledge_page_not_archived:
      'Μόνο μια αρχειοθετημένη σελίδα μπορεί να επαναφερθεί ή να διαγραφεί.',
    knowledgeErrorKnowledge_root_page:
      'Η σελίδα επισκόπησης της εταιρείας δεν μπορεί να μετακινηθεί ή να αρχειοθετηθεί.',
    knowledgeErrorKnowledge_page_cycle:
      'Μια σελίδα δεν μπορεί να μετακινηθεί κάτω από τον εαυτό της ή κάτω από μία από τις δικές της σελίδες.',
    knowledgeErrorKnowledge_parent_not_found: 'Αυτή η σελίδα δεν είναι πλέον διαθέσιμη.',
    knowledgeErrorKnowledge_parent_archived: 'Αυτή η σελίδα είναι αρχειοθετημένη. Επιλέξτε άλλη.',
    knowledgeErrorKnowledge_page_not_found: 'Αυτή η σελίδα δεν είναι πλέον διαθέσιμη.',
    knowledgeErrorKnowledge_proposal_not_found: 'Αυτή η πρόταση δεν είναι πλέον διαθέσιμη σε εσάς.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Μόνο το άτομο που υπέβαλε αυτή την πρόταση μπορεί να την αποσύρει.',
    knowledgeErrorProposal_not_pending: 'Για αυτή την πρόταση έχει ήδη ληφθεί απόφαση.',
    knowledgeErrorProposal_requester_removed:
      'Το άτομο που υπέβαλε αυτή την πρόταση δεν ανήκει πλέον στην εταιρεία, επομένως δεν μπορεί να γίνει αποδεκτή.',
    knowledgeErrorPage_archived:
      'Αυτή η σελίδα αρχειοθετήθηκε. Η αποδοχή αυτής της πρότασης θα την επαναφέρει· ελέγξτε την ξανά πρώτα.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Το Poneva δεν μπόρεσε να αποδεχτεί αυτά τα δεδομένα. Ελέγξτε τα πεδία και δοκιμάστε ξανά.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Οι σελίδες γνώσης δεν είναι διαθέσιμες αυτή τη στιγμή. Δοκιμάστε ξανά.',
    knowledgeErrorKnowledge_pages_timeout:
      'Το Poneva χρειάστηκε υπερβολικά πολύ χρόνο για να απαντήσει. Δοκιμάστε ξανά.',
    agentErrorAgent_unpublished: 'Δημοσιεύστε μια έκδοση πριν εκτελέσετε αυτόν τον agent.',
    agentErrorAgent_revision_conflict:
      'Κάποιος άλλος άλλαξε αυτόν τον agent. Φορτώστε τον ξανά πριν τον αποθηκεύσετε.',
    agentErrorAgent_run_queue_full:
      'Αυτός ο agent έχει ήδη αρκετές εκτελέσεις σε αναμονή. Δοκιμάστε ξανά σε λίγο.',
    agentErrorPublished_skill_required:
      'Επιλέξτε μια δημοσιευμένη δεξιότητα που μπορείτε να χρησιμοποιήσετε.',
    agentErrorInvalid_schedule:
      'Δεν ήταν δυνατή η ανάγνωση αυτού του προγράμματος. Ελέγξτε την ώρα ή την έκφραση cron.',
    agentErrorSchedule_too_frequent: 'Ένας agent μπορεί να εκτελείται το πολύ κάθε 15 λεπτά.',
    agentErrorAgent_edit_access_exists: 'Έχετε ήδη δικαίωμα επεξεργασίας αυτού του agent.',
    agentErrorAgent_forbidden: 'Δεν μπορείτε να αλλάξετε αυτόν τον agent.',
    agentErrorAgent_has_no_owner:
      'Ο κάτοχός του αποχώρησε, επομένως ανήκει στην εταιρεία και παραμένει agent της εταιρείας. Απενεργοποιήστε τον ή αρχειοθετήστε τον.',
    agentErrorAgent_not_found: 'Αυτός ο agent δεν είναι πλέον διαθέσιμος σε εσάς.',
    agentErrorAgent_instructions_required: 'Δώστε του οδηγίες ή καρφιτσώστε πρώτα μια δεξιότητα.',
    toolbarBulletedList: 'Λίστα με κουκκίδες',
    toolbarNumberedList: 'Αριθμημένη λίστα',
    toolbarWebLink: 'Σύνδεσμος ιστού',
    agentErrorGeneric: 'Δεν ήταν δυνατή η ολοκλήρωση αυτού του αιτήματος.',
    justNow: 'μόλις τώρα',
    editedBy: 'έγινε επεξεργασία από {name}',
    imported: 'εισήχθη',
    acceptedBy: 'έγινε αποδοχή από {name}',
    acceptedPoneva: 'Έγινε αποδοχή της πρότασης του Poneva',
    acceptedFrom: 'Έγινε αποδοχή πρότασης από {name}',
    acceptedNamed: 'Έγινε αποδοχή της πρότασης του {name}',
    acceptedSuggestion: 'Έγινε αποδοχή μιας πρότασης',
    fromMeeting: 'Από τη σύσκεψη',
    inYourChat: 'Στη συνομιλία σας',
    inNamedChat: 'Στη συνομιλία του {name}',
    inAChat: 'Σε μια συνομιλία',
    connectedAgent: 'Συνδεδεμένος βοηθός',
    connectedAgentFor: 'Συνδεδεμένος βοηθός για τον {name}',
    repositoryImport: 'Εισαγωγή αποθετηρίου',
    importedText: 'Εισηγμένο κείμενο',
    you: 'Εσείς',
    colleague: 'Ένας συνάδελφος',
    editedPage: 'Έγινε επεξεργασία της σελίδας',
    suggestedNewPage: 'Προτάθηκε νέα σελίδα',
    suggestedMove: 'Προτάθηκε μετακίνηση',
    suggestedArchive: 'Προτάθηκε αρχειοθέτηση',
    saved: 'Αποθηκεύτηκε',
    noTextYet: 'Δεν υπάρχει ακόμη κείμενο',
    openSuggestion: 'one:άνοιγμα πρότασης|other:άνοιγμα προτάσεων',
    suggestion: 'one:πρόταση|other:προτάσεις',
    archivedPage: 'one:αρχειοθετημένη σελίδα|other:αρχειοθετημένες σελίδες',
    character: 'one:χαρακτήρας|other:χαρακτήρες',
    runQueued: 'Σε αναμονή έναρξης',
    runRunning: 'Εκτελείται ακόμη',
    runApproval: 'Αναμονή έγκρισης σε αυτή τη συνομιλία',
    runCancelled: 'Διακόπηκε πριν ολοκληρωθεί',
    runFinished: 'Ολοκληρώθηκε.',
    runSavedResult: 'Αποθηκεύτηκε ένα αποτέλεσμα.',
    runCouldNotRead: 'Δεν ήταν δυνατή η ανάγνωση: {sources}.',
    runScheduled: 'Προγραμματίστηκε',
    runBy: 'Εκτελέστηκε από {name}',
    testRunBy: 'Η δοκιμαστική εκτέλεση έγινε από {name}',
    formerMember: 'πρώην μέλος',
    youLower: 'εσείς',
    colleagueLower: 'ένας συνάδελφος',
    missedTime: 'φορά',
    missedTimes: 'φορές',
    runs: 'Εκτελέσεις',
    openRunChat: 'Άνοιγμα συνομιλίας εκτέλεσης',
    watch: 'Παρακολούθηση',
    cancel: 'Ακύρωση',
    noRuns: 'Δεν υπάρχουν ακόμη εκτελέσεις.',
    skill: 'Δεξιότητα',
    skillPublished: 'Ο βοηθός χρησιμοποιεί πάντα τη δημοσιευμένη έκδοση της Δεξιότητας.',
    whenRuns: 'Πότε εκτελείται',
    day: 'Ημέρα',
    time: 'Ώρα',
    cron: 'Έκφραση Cron',
    notPublished: '· μη δημοσιευμένο',
    version: '· έκδοση {version}',
    today: 'σήμερα',
    tomorrow: 'αύριο',
    yesterday: 'χθες',
    on: 'στις',
    at: 'στις',
    underCredits: 'λιγότερο από 0,1 πιστώσεις',
    credit: 'πίστωση',
    credits: 'πιστώσεις',
    took: 'Χρειάστηκε {duration}{used}',
    andUsed: 'και χρησιμοποιήθηκαν {credits}',
    versionLabel: 'Έκδοση {version}',
    draftRevision: 'Το πρόχειρο, αναθεώρηση {version}',
    following: 'ακολουθώντας {skills}',
    timeSecond: 'δευτ.',
    timeMinute: 'λεπ.',
    timeHour: 'ώρ.',
    statusQueued: 'Σε αναμονή',
    statusRunning: 'Σε εκτέλεση',
    statusApproval: 'Απαιτείται έγκριση',
    statusDone: 'Ολοκληρώθηκε',
    statusFailed: 'Απέτυχε',
    statusCancelled: 'Ακυρώθηκε',
    loadingWorkspace: 'Φόρτωση του χώρου εργασίας σας…',
    knowledgeErrorRevision_conflict: 'Αυτή η σελίδα άλλαξε ενώ εργαζόσασταν σε αυτήν.',
    knowledgeErrorSuggestion_outdated:
      'Το κείμενο που τροποποιεί αυτή η πρόταση έχει υποστεί επεξεργασία από τότε. Μπορεί πλέον μόνο να απορριφθεί ή να αποσυρθεί.',
  },
  hu: {
    justNow: 'épp most',
    editedBy: 'szerkesztette: {name}',
    imported: 'importálva',
    acceptedBy: 'elfogadta: {name}',
    acceptedPoneva: 'Elfogadta a Poneva javaslatát',
    acceptedFrom: 'Elfogadta {name} javaslatát',
    acceptedNamed: 'Elfogadta {name} javaslatát',
    acceptedSuggestion: 'Elfogadott egy javaslatot',
    fromMeeting: 'A megbeszélésből',
    inYourChat: 'A csevegésedben',
    inNamedChat: '{name} csevegésében',
    inAChat: 'Egy csevegésben',
    connectedAgent: 'Csatlakoztatott ügynök',
    connectedAgentFor: '{name} számára csatlakoztatott ügynök',
    repositoryImport: 'Adattár importálása',
    importedText: 'Importált szöveg',
    you: 'Te',
    colleague: 'Egy kolléga',
    editedPage: 'Szerkesztette az oldalt',
    suggestedNewPage: 'Új oldal létrehozását javasolta',
    suggestedMove: 'Áthelyezést javasolt',
    suggestedArchive: 'Archiválást javasolt',
    saved: 'Mentve',
    noTextYet: 'Még nincs szöveg',
    openSuggestion: 'one:javaslat megnyitása|other:javaslatok megnyitása',
    suggestion: 'one:javaslat|other:javaslatok',
    archivedPage: 'one:archivált oldal|other:archivált oldalak',
    character: 'one:karakter|other:karakter',
    runQueued: 'Indításra vár',
    runRunning: 'Még fut',
    runApproval: 'Jóváhagyásra vár ebben a csevegésben',
    runCancelled: 'A befejezés előtt leállítva',
    runFinished: 'Befejezve.',
    runSavedResult: 'Eredmény mentve.',
    runCouldNotRead: 'Nem sikerült beolvasni: {sources}.',
    runScheduled: 'Ütemezve',
    runBy: 'Futtatta: {name}',
    testRunBy: 'Tesztfuttatás: {name}',
    formerMember: 'egy korábbi tag',
    youLower: 'te',
    colleagueLower: 'egy kolléga',
    missedTime: 'alkalom',
    missedTimes: 'alkalommal',
    runs: 'Futtatások',
    openRunChat: 'Futtatás csevegésének megnyitása',
    watch: 'Megtekintés',
    cancel: 'Mégse',
    noRuns: 'Még nincsenek futtatások.',
    skill: 'Képesség',
    skillPublished: 'Az ügynök mindig a Képesség közzétett verzióját használja.',
    whenRuns: 'Futtatás ideje',
    day: 'Nap',
    time: 'Idő',
    cron: 'Cron-kifejezés',
    notPublished: '· nincs közzétéve',
    version: '· {version} verzió',
    today: 'ma',
    tomorrow: 'holnap',
    yesterday: 'tegnap',
    on: 'ekkor:',
    at: 'órakor:',
    underCredits: '0,1 kredit alatt',
    credit: 'kredit',
    credits: 'kredit',
    took: 'Időtartam: {duration}{used}',
    andUsed: 'és {credits} kreditet használt fel',
    versionLabel: '{version} verzió',
    draftRevision: 'Piszkozat, {version}. módosítás',
    following: 'a következőket követve: {skills}',
    timeSecond: 'mp',
    timeMinute: 'perc',
    timeHour: 'óra',
    statusQueued: 'Sorba állítva',
    statusRunning: 'Fut',
    statusApproval: 'Jóváhagyás szükséges',
    statusDone: 'Kész',
    statusFailed: 'Sikertelen',
    statusCancelled: 'Megszakítva',
    loadingWorkspace: 'A munkaterület betöltése…',
    knowledgeErrorRevision_conflict: 'Ez az oldal megváltozott, miközben dolgoztál rajta.',
    knowledgeErrorSuggestion_outdated:
      'A javaslat által módosított szöveget azóta szerkesztették. Most már csak elutasítani vagy visszavonni lehet.',
    knowledgeErrorSuggestion_reason_required: 'Írja le néhány szóban, miért helyes ez a módosítás.',
    knowledgeErrorSuggestion_no_change: 'Ez nem módosítaná az oldalt.',
    knowledgeErrorSuggestion_markdown_required: 'A javasolt új oldalhoz szöveg szükséges.',
    knowledgeErrorCompany_publish_required:
      'Csak vállalati közzétevők fogadhatják el a módosításokat.',
    knowledgeErrorKnowledge_proposal_limit:
      'Vállalatánál már 200 javaslat vár felülvizsgálatra. Tekintsen át néhányat, mielőtt újabbat javasolna.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Már 50 javaslata vár döntésre. Várja meg, amíg néhányról döntés születik, vagy vonjon vissza néhányat, mielőtt újabbat javasolna.',
    knowledgeErrorKnowledge_page_too_large: 'Az oldal nagyobb 256 KB-nál. Ossza kisebb oldalakra.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Az oldal több mint 2 000 címsort tartalmaz. Ossza kisebb oldalakra.',
    knowledgeErrorKnowledge_page_limit: 'Vállalata elérte a 2 000 tudásoldalas korlátot.',
    knowledgeErrorKnowledge_page_archived: 'Ez az oldal archiválva van.',
    knowledgeErrorKnowledge_page_has_children:
      'Előbb helyezze át vagy archiválja az alatta lévő oldalakat.',
    knowledgeErrorKnowledge_page_delete_children:
      'Előbb állítsa vissza vagy törölje az alatta lévő oldalakat.',
    knowledgeErrorKnowledge_page_not_archived:
      'Csak archivált oldal állítható vissza vagy törölhető.',
    knowledgeErrorKnowledge_root_page:
      'A vállalati áttekintő oldal nem helyezhető át és nem archiválható.',
    knowledgeErrorKnowledge_page_cycle:
      'Egy oldal nem helyezhető saját maga vagy valamelyik aloldala alá.',
    knowledgeErrorKnowledge_parent_not_found: 'Ez az oldal már nem érhető el.',
    knowledgeErrorKnowledge_parent_archived: 'Ez az oldal archiválva van. Válasszon másikat.',
    knowledgeErrorKnowledge_page_not_found: 'Ez az oldal már nem érhető el.',
    knowledgeErrorKnowledge_proposal_not_found: 'Ez a javaslat már nem érhető el az Ön számára.',
    knowledgeErrorKnowledge_proposal_forbidden: 'Ezt csak a javaslattevő vonhatja vissza.',
    knowledgeErrorProposal_not_pending: 'Erről a javaslatról már megszületett a döntés.',
    knowledgeErrorProposal_requester_removed:
      'A javaslattevő már nem tagja ennek a vállalatnak, ezért a javaslat nem fogadható el.',
    knowledgeErrorPage_archived:
      'Ezt az oldalt archiválták. A javaslat elfogadása visszaállítja; előbb tekintse át újra.',
    knowledgeErrorInvalid_knowledge_page_input:
      'A Poneva nem tudta elfogadni ezt a bevitelt. Ellenőrizze a mezőket, majd próbálja újra.',
    knowledgeErrorKnowledge_pages_unavailable:
      'A tudásoldalak jelenleg nem érhetők el. Próbálja újra.',
    knowledgeErrorKnowledge_pages_timeout: 'A Poneva túl sokáig nem válaszolt. Próbálja újra.',
    agentErrorAgent_unpublished: 'Az ügynök futtatása előtt tegyen közzé egy verziót.',
    agentErrorAgent_revision_conflict:
      'Valaki más módosította ezt az ügynököt. A mentés előtt töltse újra.',
    agentErrorAgent_run_queue_full:
      'Ennek az ügynöknek már több futtatása várakozik. Próbálja újra egy pillanat múlva.',
    agentErrorPublished_skill_required: 'Válasszon egy használható, közzétett készséget.',
    agentErrorInvalid_schedule:
      'Az ütemezés nem olvasható. Ellenőrizze az időpontot vagy a cron-kifejezést.',
    agentErrorSchedule_too_frequent: 'Egy ügynök legfeljebb 15 percenként futtatható.',
    agentErrorAgent_edit_access_exists: 'Már szerkesztheti ezt az ügynököt.',
    agentErrorAgent_forbidden: 'Nem módosíthatja ezt az ügynököt.',
    agentErrorAgent_has_no_owner:
      'A tulajdonosa távozott, ezért az ügynök a vállalathoz tartozik, és vállalati ügynökként marad meg. Kapcsolja ki vagy archiválja.',
    agentErrorAgent_not_found: 'Ez az ügynök már nem érhető el az Ön számára.',
    agentErrorAgent_instructions_required:
      'Adjon neki utasításokat, vagy rögzítsen előbb egy készséget.',
    toolbarBulletedList: 'Felsorolás',
    toolbarNumberedList: 'Számozott lista',
    toolbarWebLink: 'Webhivatkozás',
    agentErrorGeneric: 'Nem sikerült befejezni ezt a kérést.',
  },
  ga: {
    knowledgeErrorSuggestion_reason_required:
      'Abair i gcúpla focal cén fáth a bhfuil an t-athrú seo ceart.',
    knowledgeErrorSuggestion_no_change: 'Ní athródh sé seo an leathanach.',
    knowledgeErrorSuggestion_markdown_required: 'Teastaíonn téacs éigin ó leathanach nua molta.',
    knowledgeErrorCompany_publish_required:
      'Ní féidir ach le foilsitheoirí na cuideachta glacadh le hathruithe.',
    knowledgeErrorKnowledge_proposal_limit:
      'Tá 200 moladh ó do chuideachta ag fanacht le hathbhreithniú cheana féin. Déan athbhreithniú ar chuid acu sula moltar tuilleadh.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Tá 50 moladh uaitse ag fanacht le cinneadh cheana féin. Fan go gcinnfear cuid acu, nó tarraing cuid acu siar, sula moltar tuilleadh.',
    knowledgeErrorKnowledge_page_too_large:
      'Tá leathanach níos mó ná 256 KB. Roinn é ina leathanaigh níos lú.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Tá níos mó ná 2,000 ceannteideal ar leathanach. Roinn é ina leathanaigh níos lú.',
    knowledgeErrorKnowledge_page_limit:
      'Tá teorainn 2,000 leathanach eolais bainte amach ag do chuideachta.',
    knowledgeErrorKnowledge_page_archived: 'Tá an leathanach seo curtha i gcartlann.',
    knowledgeErrorKnowledge_page_has_children:
      'Bog nó cuir na leathanaigh faoin leathanach seo i gcartlann ar dtús.',
    knowledgeErrorKnowledge_page_delete_children:
      'Athchóirigh nó scrios na leathanaigh faoin leathanach seo ar dtús.',
    knowledgeErrorKnowledge_page_not_archived:
      'Ní féidir ach leathanach atá i gcartlann a athchóiriú nó a scriosadh.',
    knowledgeErrorKnowledge_root_page:
      'Ní féidir leathanach forbhreathnaithe na cuideachta a bhogadh ná a chur i gcartlann.',
    knowledgeErrorKnowledge_page_cycle:
      'Ní féidir leathanach a bhogadh faoina féin ná faoi cheann dá leathanaigh féin.',
    knowledgeErrorKnowledge_parent_not_found: 'Níl an leathanach sin ar fáil a thuilleadh.',
    knowledgeErrorKnowledge_parent_archived:
      'Tá an leathanach sin i gcartlann. Roghnaigh leathanach eile.',
    knowledgeErrorKnowledge_page_not_found: 'Níl an leathanach seo ar fáil a thuilleadh.',
    knowledgeErrorKnowledge_proposal_not_found: 'Níl an moladh seo ar fáil duit a thuilleadh.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Ní féidir ach leis an duine a rinne an moladh seo é a tharraingt siar.',
    knowledgeErrorProposal_not_pending: 'Tá cinneadh déanta faoin moladh seo cheana féin.',
    knowledgeErrorProposal_requester_removed:
      'Níl an duine a rinne an moladh seo sa chuideachta a thuilleadh, mar sin ní féidir glacadh leis.',
    knowledgeErrorPage_archived:
      'Cuireadh an leathanach seo i gcartlann. Tabharfaidh glacadh leis an moladh seo ar ais é; déan athbhreithniú air arís ar dtús.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Níor éirigh le Poneva glacadh leis an ionchur seo. Seiceáil na réimsí agus bain triail eile as.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Níl leathanaigh eolais ar fáil faoi láthair. Bain triail eile as le do thoil.',
    knowledgeErrorKnowledge_pages_timeout:
      'Thóg Poneva an iomarca ama le freagairt. Bain triail eile as le do thoil.',
    agentErrorAgent_unpublished: 'Foilsigh leagan sula ritheann tú an gníomhaire seo.',
    agentErrorAgent_revision_conflict:
      "D'athraigh duine eile an gníomhaire seo. Athlódáil é sula sábhálann tú arís.",
    agentErrorAgent_run_queue_full:
      'Tá roinnt rith den ghníomhaire seo ag fanacht cheana féin. Bain triail eile as ar ball.',
    agentErrorPublished_skill_required: 'Roghnaigh Scil fhoilsithe is féidir leat a úsáid.',
    agentErrorInvalid_schedule:
      'Níorbh fhéidir an sceideal sin a léamh. Seiceáil an t-am nó an slonn cron.',
    agentErrorSchedule_too_frequent:
      'Ní féidir le gníomhaire rith níos minice ná uair amháin gach 15 nóiméad.',
    agentErrorAgent_edit_access_exists:
      'Tá cead agat an gníomhaire seo a chur in eagar cheana féin.',
    agentErrorAgent_forbidden: 'Ní féidir leat an gníomhaire seo a athrú.',
    agentErrorAgent_has_no_owner:
      "D'fhág a úinéir, mar sin is leis an gcuideachta é agus fanann sé ina ghníomhaire cuideachta. Múch é nó cuir i gcartlann é ina ionad sin.",
    agentErrorAgent_not_found: 'Níl an gníomhaire seo ar fáil duit a thuilleadh.',
    agentErrorAgent_instructions_required: 'Tabhair treoracha dó nó pionnaigh Scil ar dtús.',
    toolbarBulletedList: 'Liosta le hurchair',
    toolbarNumberedList: 'Liosta uimhrithe',
    toolbarWebLink: 'Nasc gréasáin',
    agentErrorGeneric: 'Níorbh fhéidir linn an t-iarratas seo a chur i gcrích.',
    justNow: 'díreach anois',
    editedBy: 'curtha in eagar ag {name}',
    imported: 'iompórtáilte',
    acceptedBy: 'glactha ag {name}',
    acceptedPoneva: 'Glacadh le moladh Poneva',
    acceptedFrom: 'Glacadh le moladh ó {name}',
    acceptedNamed: 'Glacadh le moladh {name}',
    acceptedSuggestion: 'Glacadh le moladh',
    fromMeeting: 'Ón gcruinniú',
    inYourChat: 'I do chomhrá',
    inNamedChat: 'I gcomhrá {name}',
    inAChat: 'I gcomhrá',
    connectedAgent: 'Gníomhaire nasctha',
    connectedAgentFor: 'Gníomhaire nasctha do {name}',
    repositoryImport: 'Iompórtáil stórtha',
    importedText: 'Téacs iompórtáilte',
    you: 'Tú',
    colleague: 'Comhghleacaí',
    editedPage: 'Cuireadh an leathanach in eagar',
    suggestedNewPage: 'Moladh leathanach nua',
    suggestedMove: 'Moladh bogadh',
    suggestedArchive: 'Moladh cartlannú',
    saved: 'Sábháilte',
    noTextYet: 'Níl aon téacs ann fós',
    openSuggestion: 'one:moladh oscailte|other:moltaí oscailte',
    suggestion: 'one:moladh|other:moltaí',
    archivedPage: 'one:leathanach cartlannaithe|other:leathanaigh chartlannaithe',
    character: 'one:carachtar|other:carachtair',
    runQueued: 'Ag fanacht le tosú',
    runRunning: 'Fós ar siúl',
    runApproval: 'Ag fanacht le ceadú sa chomhrá seo',
    runCancelled: 'Stopadh sular chríochnaigh sé',
    runFinished: 'Críochnaithe.',
    runSavedResult: 'Toradh sábháilte.',
    runCouldNotRead: 'Níorbh fhéidir a léamh: {sources}.',
    runScheduled: 'Sceidealaithe',
    runBy: 'Rith ag {name}',
    testRunBy: 'Rith thástála ag {name}',
    formerMember: 'iarchomhalta',
    youLower: 'tú',
    colleagueLower: 'comhghleacaí',
    missedTime: 'uair',
    missedTimes: 'uaireanta',
    runs: 'Ritheanna',
    openRunChat: 'Oscail comhrá an rith',
    watch: 'Féach',
    cancel: 'Cealaigh',
    noRuns: 'Níl aon rith ann fós.',
    skill: 'Scil',
    skillPublished: 'Úsáideann an gníomhaire leagan foilsithe na Scile i gcónaí.',
    whenRuns: 'Nuair a ritheann sé',
    day: 'Lá',
    time: 'Am',
    cron: 'Slonn cron',
    notPublished: '· neamhfhoilsithe',
    version: '· leagan {version}',
    today: 'inniu',
    tomorrow: 'amárach',
    yesterday: 'inné',
    on: 'ar',
    at: 'ag',
    underCredits: 'faoi bhun 0.1 creidmheasa',
    credit: 'creidmheas',
    credits: 'creidmheasanna',
    took: 'Thóg sé {duration}{used}',
    andUsed: 'agus d’úsáid sé {credits}',
    versionLabel: 'Leagan {version}',
    draftRevision: 'Dréacht, leasú {version}',
    following: 'ag leanúint {skills}',
    timeSecond: 's',
    timeMinute: 'nóim',
    timeHour: 'u',
    statusQueued: 'Sa scuaine',
    statusRunning: 'Ar siúl',
    statusApproval: 'Faomhadh de dhíth',
    statusDone: 'Déanta',
    statusFailed: 'Theip air',
    statusCancelled: 'Cealaithe',
    loadingWorkspace: 'Ag lódáil do spás oibre…',
    knowledgeErrorRevision_conflict: 'Athraíodh an leathanach seo agus tú ag obair air.',
    knowledgeErrorSuggestion_outdated:
      'Cuireadh an téacs a athraíonn an moladh seo in eagar ó shin. Ní féidir an moladh a dhiúltú ná a tharraingt siar anois.',
  },
  it: {
    justNow: 'proprio ora',
    editedBy: 'modificato da {name}',
    imported: 'importato',
    acceptedBy: 'accettato da {name}',
    acceptedPoneva: 'Suggerimento di Poneva accettato',
    acceptedFrom: 'Suggerimento di {name} accettato',
    acceptedNamed: 'Suggerimento di {name} accettato',
    acceptedSuggestion: 'Suggerimento accettato',
    fromMeeting: 'Dalla riunione',
    inYourChat: 'Nella tua chat',
    inNamedChat: 'Nella chat di {name}',
    inAChat: 'In una chat',
    connectedAgent: 'Agente connesso',
    connectedAgentFor: 'Agente connesso per {name}',
    repositoryImport: 'Importazione del repository',
    importedText: 'Testo importato',
    you: 'Tu',
    colleague: 'Un collega',
    editedPage: 'Pagina modificata',
    suggestedNewPage: 'Nuova pagina suggerita',
    suggestedMove: 'Spostamento suggerito',
    suggestedArchive: 'Archiviazione suggerita',
    saved: 'Salvato',
    noTextYet: 'Ancora nessun testo',
    openSuggestion: 'one:apri suggerimento|other:apri suggerimenti',
    suggestion: 'one:suggerimento|other:suggerimenti',
    archivedPage: 'one:pagina archiviata|other:pagine archiviate',
    character: 'one:carattere|other:caratteri',
    runQueued: 'In attesa di avvio',
    runRunning: 'Ancora in esecuzione',
    runApproval: "In attesa di un'approvazione in questa chat",
    runCancelled: 'Interrotto prima del completamento',
    runFinished: 'Completato.',
    runSavedResult: 'Risultato salvato.',
    runCouldNotRead: 'Impossibile leggere: {sources}.',
    runScheduled: 'Pianificato',
    runBy: 'Eseguito da {name}',
    testRunBy: 'Esecuzione di test di {name}',
    formerMember: 'un ex membro',
    youLower: 'tu',
    colleagueLower: 'un collega',
    missedTime: 'volta',
    missedTimes: 'volte',
    runs: 'Esecuzioni',
    openRunChat: "Apri la chat dell'esecuzione",
    watch: 'Guarda',
    cancel: 'Annulla',
    noRuns: 'Ancora nessuna esecuzione.',
    skill: 'Skill',
    skillPublished: "L'agente usa sempre la versione pubblicata della Skill.",
    whenRuns: 'Quando viene eseguita',
    day: 'Giorno',
    time: 'Ora',
    cron: 'Espressione cron',
    notPublished: '· non pubblicata',
    version: '· versione {version}',
    today: 'oggi',
    tomorrow: 'domani',
    yesterday: 'ieri',
    on: 'il',
    at: 'alle',
    underCredits: 'meno di 0,1 crediti',
    credit: 'credito',
    credits: 'crediti',
    took: 'Ha richiesto {duration}{used}',
    andUsed: 'e ha usato {credits}',
    versionLabel: 'Versione {version}',
    draftRevision: 'La bozza, revisione {version}',
    following: 'seguendo {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'In coda',
    statusRunning: 'In esecuzione',
    statusApproval: 'Richiede approvazione',
    statusDone: 'Completata',
    statusFailed: 'Non riuscita',
    statusCancelled: 'Annullata',
    loadingWorkspace: 'Caricamento del tuo workspace…',
    knowledgeErrorRevision_conflict: 'Questa pagina è cambiata mentre ci lavoravi.',
    knowledgeErrorSuggestion_outdated:
      'Il testo modificato da questo suggerimento è stato modificato nel frattempo. Ora può solo essere rifiutato o ritirato.',
    knowledgeErrorSuggestion_reason_required:
      'Spiega in poche parole perché questa modifica è corretta.',
    knowledgeErrorSuggestion_no_change: 'Questa modifica non cambierebbe la pagina.',
    knowledgeErrorSuggestion_markdown_required:
      'Una nuova pagina suggerita deve contenere del testo.',
    knowledgeErrorCompany_publish_required:
      "Solo i pubblicatori dell'azienda possono accettare le modifiche.",
    knowledgeErrorKnowledge_proposal_limit:
      'La tua azienda ha già 200 suggerimenti in attesa di revisione. Esaminane alcuni prima di inviarne altri.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Hai già 50 suggerimenti in attesa di revisione. Attendi che alcuni vengano decisi oppure ritirane alcuni prima di inviarne altri.',
    knowledgeErrorKnowledge_page_too_large:
      'Una pagina supera i 256 KB. Dividila in pagine più piccole.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Una pagina contiene più di 2.000 titoli. Dividila in pagine più piccole.',
    knowledgeErrorKnowledge_page_limit:
      'La tua azienda ha raggiunto il limite di 2.000 pagine della knowledge base.',
    knowledgeErrorKnowledge_page_archived: 'Questa pagina è archiviata.',
    knowledgeErrorKnowledge_page_has_children:
      'Prima sposta o archivia le pagine contenute qui sotto.',
    knowledgeErrorKnowledge_page_delete_children:
      'Prima ripristina o elimina le pagine contenute qui sotto.',
    knowledgeErrorKnowledge_page_not_archived:
      'Solo una pagina archiviata può essere ripristinata o eliminata.',
    knowledgeErrorKnowledge_root_page:
      "La pagina di panoramica dell'azienda non può essere spostata o archiviata.",
    knowledgeErrorKnowledge_page_cycle:
      'Una pagina non può essere spostata sotto se stessa o sotto una delle proprie pagine.',
    knowledgeErrorKnowledge_parent_not_found: 'Quella pagina non è più disponibile.',
    knowledgeErrorKnowledge_parent_archived: "Quella pagina è archiviata. Scegline un'altra.",
    knowledgeErrorKnowledge_page_not_found: 'Questa pagina non è più disponibile.',
    knowledgeErrorKnowledge_proposal_not_found: 'Questo suggerimento non è più disponibile per te.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Solo chi ha inviato questo suggerimento può ritirarlo.',
    knowledgeErrorProposal_not_pending: 'Questo suggerimento è già stato deciso.',
    knowledgeErrorProposal_requester_removed:
      'Chi ha inviato questo suggerimento non fa più parte di questa azienda, quindi non può essere accettato.',
    knowledgeErrorPage_archived:
      'Questa pagina è stata archiviata. Accettando questo suggerimento verrà ripristinata; esaminalo di nuovo prima.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva non ha potuto accettare questo input. Controlla i campi e riprova.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Le pagine della knowledge base non sono al momento disponibili. Riprova.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva ha impiegato troppo tempo per rispondere. Riprova.',
    agentErrorAgent_unpublished: 'Pubblica una versione prima di eseguire questo agente.',
    agentErrorAgent_revision_conflict:
      'Qualcun altro ha modificato questo agente. Ricaricalo prima di salvarlo di nuovo.',
    agentErrorAgent_run_queue_full:
      'Questo agente ha già diverse esecuzioni in attesa. Riprova tra poco.',
    agentErrorPublished_skill_required: 'Scegli una competenza pubblicata che puoi usare.',
    agentErrorInvalid_schedule:
      "Non è stato possibile leggere questa pianificazione. Controlla l'orario o l'espressione cron.",
    agentErrorSchedule_too_frequent: 'Un agente può essere eseguito al massimo ogni 15 minuti.',
    agentErrorAgent_edit_access_exists: 'Puoi già modificare questo agente.',
    agentErrorAgent_forbidden: 'Non puoi modificare questo agente.',
    agentErrorAgent_has_no_owner:
      "Il proprietario ha lasciato l'azienda, quindi l'agente appartiene all'azienda e resta un agente aziendale. Disattivalo o archivialo.",
    agentErrorAgent_not_found: 'Questo agente non è più disponibile per te.',
    agentErrorAgent_instructions_required:
      'Aggiungi istruzioni o fissa una competenza prima di procedere.',
    toolbarBulletedList: 'Elenco puntato',
    toolbarNumberedList: 'Elenco numerato',
    toolbarWebLink: 'Link web',
    agentErrorGeneric: 'Non è stato possibile completare questa richiesta.',
  },
  lv: {
    knowledgeErrorSuggestion_reason_required: 'Īsi paskaidrojiet, kāpēc šīs izmaiņas ir pamatotas.',
    knowledgeErrorSuggestion_no_change: 'Tas nemainītu lapu.',
    knowledgeErrorSuggestion_markdown_required: 'Ieteiktajai jaunajai lapai nepieciešams teksts.',
    knowledgeErrorCompany_publish_required: 'Izmaiņas var apstiprināt tikai uzņēmuma publicētāji.',
    knowledgeErrorKnowledge_proposal_limit:
      'Jūsu uzņēmumā jau ir 200 ieteikumu, kas gaida pārskatīšanu. Pirms jaunu ieteikumu iesniegšanas pārskatiet dažus no tiem.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Jums jau ir 50 ieteikumu, kas gaida pārskatīšanu. Pirms iesniegt jaunus, pagaidiet, līdz daži tiks izlemti, vai atsauciet dažus no tiem.',
    knowledgeErrorKnowledge_page_too_large:
      'Lapa ir lielāka par 256 KB. Sadaliet to mazākās lapās.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Lapā ir vairāk nekā 2000 virsrakstu. Sadaliet to mazākās lapās.',
    knowledgeErrorKnowledge_page_limit:
      'Jūsu uzņēmums ir sasniedzis 2000 zināšanu lapu ierobežojumu.',
    knowledgeErrorKnowledge_page_archived: 'Šī lapa ir arhivēta.',
    knowledgeErrorKnowledge_page_has_children:
      'Vispirms pārvietojiet vai arhivējiet šīs lapas apakšlapas.',
    knowledgeErrorKnowledge_page_delete_children:
      'Vispirms atjaunojiet vai izdzēsiet šīs lapas apakšlapas.',
    knowledgeErrorKnowledge_page_not_archived: 'Atjaunot vai izdzēst var tikai arhivētu lapu.',
    knowledgeErrorKnowledge_root_page: 'Uzņēmuma pārskata lapu nevar pārvietot vai arhivēt.',
    knowledgeErrorKnowledge_page_cycle:
      'Lapu nevar pārvietot zem tās pašas vai kādas no tās apakšlapām.',
    knowledgeErrorKnowledge_parent_not_found: 'Šī lapa vairs nav pieejama.',
    knowledgeErrorKnowledge_parent_archived: 'Šī lapa ir arhivēta. Izvēlieties citu.',
    knowledgeErrorKnowledge_page_not_found: 'Šī lapa vairs nav pieejama.',
    knowledgeErrorKnowledge_proposal_not_found: 'Šis ieteikums jums vairs nav pieejams.',
    knowledgeErrorKnowledge_proposal_forbidden: 'To var atsaukt tikai persona, kas to ieteica.',
    knowledgeErrorProposal_not_pending: 'Par šo ieteikumu jau ir pieņemts lēmums.',
    knowledgeErrorProposal_requester_removed:
      'Persona, kas to ieteica, vairs nav šajā uzņēmumā, tāpēc ieteikumu nevar apstiprināt.',
    knowledgeErrorPage_archived:
      'Šī lapa tika arhivēta. Šī ieteikuma apstiprināšana to atjaunos; vispirms pārskatiet ieteikumu vēlreiz.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva nevarēja pieņemt šo ievadi. Pārbaudiet laukus un mēģiniet vēlreiz.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Zināšanu lapas pašlaik nav pieejamas. Lūdzu, mēģiniet vēlreiz.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva atbildes sagatavošana aizņēma pārāk ilgu laiku. Lūdzu, mēģiniet vēlreiz.',
    agentErrorAgent_unpublished: 'Pirms šī aģenta palaišanas publicējiet tā versiju.',
    agentErrorAgent_revision_conflict:
      'Kāds cits ir mainījis šo aģentu. Pirms atkārtotas saglabāšanas atkārtoti ielādējiet to.',
    agentErrorAgent_run_queue_full:
      'Šim aģentam jau gaida vairākas palaišanas. Pēc brīža mēģiniet vēlreiz.',
    agentErrorPublished_skill_required: 'Izvēlieties publicētu prasmi, ko varat izmantot.',
    agentErrorInvalid_schedule: 'Šo grafiku nevarēja nolasīt. Pārbaudiet laiku vai cron izteiksmi.',
    agentErrorSchedule_too_frequent: 'Aģentu var palaist ne biežāk kā reizi 15 minūtēs.',
    agentErrorAgent_edit_access_exists: 'Jums jau ir tiesības rediģēt šo aģentu.',
    agentErrorAgent_forbidden: 'Jūs nevarat mainīt šo aģentu.',
    agentErrorAgent_has_no_owner:
      'Tā īpašnieks ir aizgājis, tāpēc aģents pieder uzņēmumam un paliek uzņēmuma aģents. Tā vietā izslēdziet to vai arhivējiet.',
    agentErrorAgent_not_found: 'Šis aģents jums vairs nav pieejams.',
    agentErrorAgent_instructions_required:
      'Sniedziet tam norādījumus vai vispirms piespraudiet prasmi.',
    toolbarBulletedList: 'Saraksts ar aizzīmēm',
    toolbarNumberedList: 'Numurēts saraksts',
    toolbarWebLink: 'Tīmekļa saite',
    agentErrorGeneric: 'Mums neizdevās izpildīt šo pieprasījumu.',
    justNow: 'tikko',
    editedBy: 'rediģēja {name}',
    imported: 'importēts',
    acceptedBy: 'pieņēma {name}',
    acceptedPoneva: 'Pieņemts Poneva ieteikums',
    acceptedFrom: 'Pieņemts {name} ieteikums',
    acceptedNamed: 'Pieņemts {name} ieteikums',
    acceptedSuggestion: 'Pieņemts ieteikums',
    fromMeeting: 'No sapulces',
    inYourChat: 'Jūsu tērzēšanā',
    inNamedChat: 'Tērzēšanā ar {name}',
    inAChat: 'Tērzēšanā',
    connectedAgent: 'Pievienots aģents',
    connectedAgentFor: 'Aģents, kas pievienots {name}',
    repositoryImport: 'Repozitorija imports',
    importedText: 'Importēts teksts',
    you: 'Jūs',
    colleague: 'Kolēģis',
    editedPage: 'Lapa rediģēta',
    suggestedNewPage: 'Ieteica jaunu lapu',
    suggestedMove: 'Ieteica pārvietošanu',
    suggestedArchive: 'Ieteica arhivēšanu',
    saved: 'Saglabāts',
    noTextYet: 'Teksta vēl nav',
    openSuggestion: 'one:atvērts ieteikums|other:atvērti ieteikumi',
    suggestion: 'one:ieteikums|other:ieteikumi',
    archivedPage: 'one:arhivēta lapa|other:arhivētas lapas',
    character: 'one:rakstzīme|other:rakstzīmes',
    runQueued: 'Gaida sākšanu',
    runRunning: 'Joprojām darbojas',
    runApproval: 'Gaida apstiprinājumu šajā tērzēšanā',
    runCancelled: 'Apturēts, pirms pabeigts',
    runFinished: 'Pabeigts.',
    runSavedResult: 'Rezultāts saglabāts.',
    runCouldNotRead: 'Neizdevās nolasīt: {sources}.',
    runScheduled: 'Ieplānots',
    runBy: 'Izpildi veica {name}',
    testRunBy: 'Testa izpildi veica {name}',
    formerMember: 'bijušais dalībnieks',
    youLower: 'jūs',
    colleagueLower: 'kolēģis',
    missedTime: 'reizi',
    missedTimes: 'reizes',
    runs: 'Izpildes',
    openRunChat: 'Atvērt izpildes tērzēšanu',
    watch: 'Skatīties',
    cancel: 'Atcelt',
    noRuns: 'Izpildes vēl nav.',
    skill: 'Prasme',
    skillPublished: 'Aģents vienmēr izmanto Prasmes publicēto versiju.',
    whenRuns: 'Kad tā tiek izpildīta',
    day: 'Diena',
    time: 'Laiks',
    cron: 'Cron izteiksme',
    notPublished: '· nav publicēta',
    version: '· versija {version}',
    today: 'šodien',
    tomorrow: 'rīt',
    yesterday: 'vakar',
    on: 'datumā',
    at: 'plkst.',
    underCredits: 'mazāk nekā 0,1 kredīta',
    credit: 'kredīts',
    credits: 'kredīti',
    took: 'Ilga {duration}{used}',
    andUsed: 'un tika izmantoti {credits}',
    versionLabel: 'Versija {version}',
    draftRevision: 'Melnraksts, redakcija {version}',
    following: 'sekojot {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Rindā',
    statusRunning: 'Darbojas',
    statusApproval: 'Nepieciešams apstiprinājums',
    statusDone: 'Pabeigts',
    statusFailed: 'Neizdevās',
    statusCancelled: 'Atcelts',
    loadingWorkspace: 'Notiek jūsu darbvietas ielāde…',
    knowledgeErrorRevision_conflict: 'Šī lapa mainījās, kamēr ar to strādājāt.',
    knowledgeErrorSuggestion_outdated:
      'Teksts, ko šis ieteikums maina, kopš tā laika ir rediģēts. Tagad to var tikai noraidīt vai atsaukt.',
  },
  lt: {
    knowledgeErrorSuggestion_reason_required:
      'Trumpai paaiškinkite, kodėl šis pakeitimas yra tinkamas.',
    knowledgeErrorSuggestion_no_change: 'Tai nepakeistų puslapio.',
    knowledgeErrorSuggestion_markdown_required: 'Siūlomam naujam puslapiui reikia teksto.',
    knowledgeErrorCompany_publish_required: 'Pakeitimus gali priimti tik įmonės leidėjai.',
    knowledgeErrorKnowledge_proposal_limit:
      'Jūsų įmonė jau turi 200 pasiūlymų, laukiančių peržiūros. Prieš teikdami daugiau, peržiūrėkite kai kuriuos iš jų.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Jau turite 50 pasiūlymų, laukiančių peržiūros. Palaukite, kol kai kurie bus išspręsti, arba atšaukite dalį jų, ir tik tada teikite daugiau.',
    knowledgeErrorKnowledge_page_too_large:
      'Puslapis yra didesnis nei 256 KB. Padalykite jį į mažesnius puslapius.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Puslapyje yra daugiau nei 2 000 antraščių. Padalykite jį į mažesnius puslapius.',
    knowledgeErrorKnowledge_page_limit: 'Jūsų įmonė pasiekė 2 000 žinių puslapių limitą.',
    knowledgeErrorKnowledge_page_archived: 'Šis puslapis suarchyvuotas.',
    knowledgeErrorKnowledge_page_has_children:
      'Pirmiausia perkelkite arba suarchyvuokite po juo esančius puslapius.',
    knowledgeErrorKnowledge_page_delete_children:
      'Pirmiausia atkurkite arba ištrinkite po juo esančius puslapius.',
    knowledgeErrorKnowledge_page_not_archived:
      'Atkurti arba ištrinti galima tik suarchyvuotą puslapį.',
    knowledgeErrorKnowledge_root_page:
      'Įmonės apžvalgos puslapio negalima perkelti arba suarchyvuoti.',
    knowledgeErrorKnowledge_page_cycle:
      'Puslapio negalima perkelti po juo pačiu arba po vienu iš jo puslapių.',
    knowledgeErrorKnowledge_parent_not_found: 'Šis puslapis nebepasiekiamas.',
    knowledgeErrorKnowledge_parent_archived: 'Šis puslapis suarchyvuotas. Pasirinkite kitą.',
    knowledgeErrorKnowledge_page_not_found: 'Šis puslapis nebepasiekiamas.',
    knowledgeErrorKnowledge_proposal_not_found: 'Šis pasiūlymas jums nebepasiekiamas.',
    knowledgeErrorKnowledge_proposal_forbidden: 'Šį pasiūlymą atšaukti gali tik jį pateikęs asmuo.',
    knowledgeErrorProposal_not_pending: 'Šis pasiūlymas jau išspręstas.',
    knowledgeErrorProposal_requester_removed:
      'Šį pasiūlymą pateikęs asmuo nebėra šioje įmonėje, todėl jo priimti negalima.',
    knowledgeErrorPage_archived:
      'Šis puslapis buvo suarchyvuotas. Priėmus šį pasiūlymą jis bus atkurtas; pirmiausia dar kartą jį peržiūrėkite.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva negalėjo priimti šios įvesties. Patikrinkite laukus ir bandykite dar kartą.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Žinių puslapiai šiuo metu nepasiekiami. Bandykite dar kartą.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva atsakė per ilgai. Bandykite dar kartą.',
    agentErrorAgent_unpublished: 'Prieš paleisdami šį agentą paskelbkite jo versiją.',
    agentErrorAgent_revision_conflict:
      'Kažkas kitas pakeitė šį agentą. Prieš išsaugodami dar kartą, įkelkite jį iš naujo.',
    agentErrorAgent_run_queue_full:
      'Šiam agentui jau laukia keli paleidimai. Po akimirkos bandykite dar kartą.',
    agentErrorPublished_skill_required: 'Pasirinkite paskelbtą Įgūdį, kurį galite naudoti.',
    agentErrorInvalid_schedule:
      'Nepavyko perskaityti šio tvarkaraščio. Patikrinkite laiką arba cron išraišką.',
    agentErrorSchedule_too_frequent:
      'Agentas gali būti paleidžiamas ne dažniau kaip kas 15 minučių.',
    agentErrorAgent_edit_access_exists: 'Jau galite redaguoti šį agentą.',
    agentErrorAgent_forbidden: 'Negalite keisti šio agento.',
    agentErrorAgent_has_no_owner:
      'Jo savininkas išėjo, todėl jis priklauso įmonei ir lieka įmonės agentu. Vietoj to jį išjunkite arba suarchyvuokite.',
    agentErrorAgent_not_found: 'Šis agentas jums nebepasiekiamas.',
    agentErrorAgent_instructions_required:
      'Pateikite jam instrukcijas arba pirmiausia prisegkite Įgūdį.',
    toolbarBulletedList: 'Sąrašas su ženkleliais',
    toolbarNumberedList: 'Numeruotas sąrašas',
    toolbarWebLink: 'Žiniatinklio nuoroda',
    agentErrorGeneric: 'Nepavyko įvykdyti šios užklausos.',
    justNow: 'ką tik',
    editedBy: 'redagavo {name}',
    imported: 'importuota',
    acceptedBy: 'priėmė {name}',
    acceptedPoneva: 'Priimtas „Poneva“ pasiūlymas',
    acceptedFrom: 'Priimtas {name} pasiūlymas',
    acceptedNamed: 'Priimtas {name} pasiūlymas',
    acceptedSuggestion: 'Priimtas pasiūlymas',
    fromMeeting: 'Iš susitikimo',
    inYourChat: 'Jūsų pokalbyje',
    inNamedChat: '{name} pokalbyje',
    inAChat: 'Pokalbyje',
    connectedAgent: 'Prijungtas agentas',
    connectedAgentFor: 'Prijungtas agentas naudotojui {name}',
    repositoryImport: 'Saugyklos importavimas',
    importedText: 'Importuotas tekstas',
    you: 'Jūs',
    colleague: 'Kolega',
    editedPage: 'Puslapis redaguotas',
    suggestedNewPage: 'Pasiūlė naują puslapį',
    suggestedMove: 'Pasiūlė perkelti',
    suggestedArchive: 'Pasiūlė archyvuoti',
    saved: 'Išsaugota',
    noTextYet: 'Teksto dar nėra',
    openSuggestion: 'one:atidaryti pasiūlymą|other:atidaryti pasiūlymus',
    suggestion: 'one:pasiūlymas|other:pasiūlymai',
    archivedPage: 'one:archyvuotas puslapis|other:archyvuoti puslapiai',
    character: 'one:simbolis|other:simboliai',
    runQueued: 'Laukiama pradžios',
    runRunning: 'Vis dar vykdoma',
    runApproval: 'Laukiama patvirtinimo šiame pokalbyje',
    runCancelled: 'Sustabdyta nebaigus',
    runFinished: 'Baigta.',
    runSavedResult: 'Rezultatas išsaugotas.',
    runCouldNotRead: 'Nepavyko perskaityti: {sources}.',
    runScheduled: 'Suplanuota',
    runBy: 'Paleido {name}',
    testRunBy: 'Bandomąjį paleidimą paleido {name}',
    formerMember: 'buvęs narys',
    youLower: 'jūs',
    colleagueLower: 'kolega',
    missedTime: 'kartą',
    missedTimes: 'kartus',
    runs: 'Paleidimai',
    openRunChat: 'Atidaryti paleidimo pokalbį',
    watch: 'Stebėti',
    cancel: 'Atšaukti',
    noRuns: 'Paleidimų dar nėra.',
    skill: 'Įgūdis',
    skillPublished: 'Agentas visada naudoja paskelbtą Įgūdžio versiją.',
    whenRuns: 'Kada vykdoma',
    day: 'Diena',
    time: 'Laikas',
    cron: '„Cron“ išraiška',
    notPublished: '· nepaskelbta',
    version: '· versija {version}',
    today: 'šiandien',
    tomorrow: 'rytoj',
    yesterday: 'vakar',
    on: 'dieną',
    at: 'val.',
    underCredits: 'mažiau nei 0,1 kredito',
    credit: 'kreditas',
    credits: 'kreditai',
    took: 'Truko {duration}{used}',
    andUsed: 'ir panaudota {credits}',
    versionLabel: 'Versija {version}',
    draftRevision: 'Juodraštis, versija {version}',
    following: 'pagal {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'val.',
    statusQueued: 'Eilėje',
    statusRunning: 'Vykdoma',
    statusApproval: 'Reikia patvirtinimo',
    statusDone: 'Atlikta',
    statusFailed: 'Nepavyko',
    statusCancelled: 'Atšaukta',
    loadingWorkspace: 'Įkeliama jūsų darbo sritis…',
    knowledgeErrorRevision_conflict: 'Šis puslapis pasikeitė, kol jį tvarkėte.',
    knowledgeErrorSuggestion_outdated:
      'Tekstas, kurį keičia šis pasiūlymas, nuo tada buvo redaguotas. Dabar jį galima tik atmesti arba atšaukti.',
  },
  mt: {
    knowledgeErrorSuggestion_reason_required: 'Għid fi ftit kliem għaliex din il-bidla hija tajba.',
    knowledgeErrorSuggestion_no_change: 'Dan ma jbiddilx il-paġna.',
    knowledgeErrorSuggestion_markdown_required: 'Paġna ġdida ssuġġerita teħtieġ xi test.',
    knowledgeErrorCompany_publish_required:
      'Il-pubblikaturi tal-kumpanija biss jistgħu jaċċettaw il-bidliet.',
    knowledgeErrorKnowledge_proposal_limit:
      'Il-kumpanija tiegħek diġà għandha 200 suġġeriment jistennew ir-reviżjoni. Irrevedi xi wħud qabel tissuġġerixxi aktar.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Diġà għandek 50 suġġeriment jistennew id-deċiżjoni. Stenna sakemm jittieħdu xi deċiżjonijiet, jew irtira xi wħud, qabel tissuġġerixxi aktar.',
    knowledgeErrorKnowledge_page_too_large: 'Paġna hija akbar minn 256 KB. Aqsamha f’paġni iżgħar.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Paġna għandha aktar minn 2,000 intestatura. Aqsamha f’paġni iżgħar.',
    knowledgeErrorKnowledge_page_limit:
      'Il-kumpanija tiegħek laħqet il-limitu ta’ 2,000 paġna tal-għarfien.',
    knowledgeErrorKnowledge_page_archived: 'Din il-paġna tinsab fl-arkivju.',
    knowledgeErrorKnowledge_page_has_children: 'Mexxi jew arkivja l-paġni ta’ taħtha l-ewwel.',
    knowledgeErrorKnowledge_page_delete_children:
      'Irrestawra jew ħassar il-paġni ta’ taħtha l-ewwel.',
    knowledgeErrorKnowledge_page_not_archived:
      'Paġna fl-arkivju biss tista’ tiġi rrestawrata jew imħassra.',
    knowledgeErrorKnowledge_root_page:
      'Il-paġna tal-ħarsa ġenerali tal-kumpanija ma tistax tiġi mċaqalqa jew arkivjata.',
    knowledgeErrorKnowledge_page_cycle:
      'Paġna ma tistax titmexxa taħtha nnifisha jew taħt waħda mill-paġni tagħha stess.',
    knowledgeErrorKnowledge_parent_not_found: 'Dik il-paġna m’għadhiex disponibbli.',
    knowledgeErrorKnowledge_parent_archived: 'Dik il-paġna tinsab fl-arkivju. Agħżel oħra.',
    knowledgeErrorKnowledge_page_not_found: 'Din il-paġna m’għadhiex disponibbli.',
    knowledgeErrorKnowledge_proposal_not_found: 'Dan is-suġġeriment m’għadux disponibbli għalik.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Il-persuna li ssuġġeriet dan biss tista’ tirtirah.',
    knowledgeErrorProposal_not_pending: 'Dan is-suġġeriment diġà ġie deċiż.',
    knowledgeErrorProposal_requester_removed:
      'Il-persuna li ssuġġeriet dan m’għadhiex f’din il-kumpanija, għalhekk ma jistax jiġi aċċettat.',
    knowledgeErrorPage_archived:
      'Din il-paġna ġiet arkivjata. L-aċċettazzjoni ta’ dan is-suġġeriment iġġibha lura; irrevediha mill-ġdid l-ewwel.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva ma setax jaċċetta dan l-input. Iċċekkja l-oqsma u erġa’ pprova.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Il-paġni tal-għarfien bħalissa mhumiex disponibbli. Erġa’ pprova.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva dam wisq biex iwieġeb. Erġa’ pprova.',
    agentErrorAgent_unpublished: 'Ippubblika verżjoni qabel ma tħaddem dan l-aġent.',
    agentErrorAgent_revision_conflict:
      'Xi ħadd ieħor biddel dan l-aġent. Erġa’ għabbu qabel issalva mill-ġdid.',
    agentErrorAgent_run_queue_full:
      'Dan l-aġent diġà għandu diversi eżekuzzjonijiet jistennew. Erġa’ pprova wara ftit.',
    agentErrorPublished_skill_required: 'Agħżel Ħila ppubblikata li tista’ tuża.',
    agentErrorInvalid_schedule:
      'Dik l-iskeda ma setgħetx tinqara. Iċċekkja l-ħin jew l-espressjoni cron.',
    agentErrorSchedule_too_frequent: 'Aġent jista’ jaħdem l-aktar darba kull 15-il minuta.',
    agentErrorAgent_edit_access_exists: 'Diġà tista’ teditja dan l-aġent.',
    agentErrorAgent_forbidden: 'Ma tistax tbiddel dan l-aġent.',
    agentErrorAgent_has_no_owner:
      'Is-sid tiegħu telaq, għalhekk issa jappartjeni lill-kumpanija u jibqa’ aġent tal-kumpanija. Itfih jew arkivjah minflok.',
    agentErrorAgent_not_found: 'Dan l-aġent m’għadux disponibbli għalik.',
    agentErrorAgent_instructions_required: 'Agħtih istruzzjonijiet jew ippinja Ħila l-ewwel.',
    toolbarBulletedList: 'Lista bil-punti',
    toolbarNumberedList: 'Lista nnumerata',
    toolbarWebLink: 'Link tal-web',
    agentErrorGeneric: 'Ma stajniex inlestu din it-talba.',
    justNow: 'issa',
    editedBy: 'editjat minn {name}',
    imported: 'importat',
    acceptedBy: 'aċċettat minn {name}',
    acceptedPoneva: 'Aċċetta s-suġġeriment ta’ Poneva',
    acceptedFrom: 'Aċċetta suġġeriment mingħand {name}',
    acceptedNamed: 'Aċċetta s-suġġeriment ta’ {name}',
    acceptedSuggestion: 'Aċċetta suġġeriment',
    fromMeeting: 'Mil-laqgħa',
    inYourChat: 'Fiċ-chat tiegħek',
    inNamedChat: 'Fiċ-chat ta’ {name}',
    inAChat: 'Fi chat',
    connectedAgent: 'Aġent konness',
    connectedAgentFor: 'Aġent konness għal {name}',
    repositoryImport: 'Importazzjoni tar-repożitorju',
    importedText: 'Test importat',
    you: 'Int',
    colleague: 'Kollega',
    editedPage: 'Editja l-paġna',
    suggestedNewPage: 'Issuġġerixxa paġna ġdida',
    suggestedMove: 'Issuġġerixxa ċaqliq',
    suggestedArchive: 'Issuġġerixxa l-arkivjar',
    saved: 'Salvat',
    noTextYet: 'Għad m’hemmx test',
    openSuggestion: 'one:suġġeriment miftuħ|other:suġġerimenti miftuħa',
    suggestion: 'one:suġġeriment|other:suġġerimenti',
    archivedPage: 'one:paġna arkivjata|other:paġni arkivjati',
    character: 'one:karattru|other:karattri',
    runQueued: 'Qed jistenna biex jibda',
    runRunning: 'Għadu għaddej',
    runApproval: 'Qed jistenna approvazzjoni f’dan iċ-chat',
    runCancelled: 'Twaqqaf qabel ma spiċċa',
    runFinished: 'Lesta.',
    runSavedResult: 'Riżultat salvat.',
    runCouldNotRead: 'Ma setax jaqra: {sources}.',
    runScheduled: 'Skedat',
    runBy: 'Imħaddem minn {name}',
    testRunBy: 'Test imħaddem minn {name}',
    formerMember: 'eks membru',
    youLower: 'int',
    colleagueLower: 'kollega',
    missedTime: 'darba',
    missedTimes: 'darbiet',
    runs: 'Eżekuzzjonijiet',
    openRunChat: 'Iftaħ iċ-chat tal-eżekuzzjoni',
    watch: 'Ara',
    cancel: 'Ikkanċella',
    noRuns: 'Għad m’hemmx eżekuzzjonijiet.',
    skill: 'Ħila',
    skillPublished: 'L-aġent dejjem juża l-verżjoni ppubblikata tal-Ħila.',
    whenRuns: 'Meta titħaddem',
    day: 'Jum',
    time: 'Ħin',
    cron: 'Espressjoni cron',
    notPublished: '· mhux ippubblikata',
    version: '· verżjoni {version}',
    today: 'illum',
    tomorrow: 'għada',
    yesterday: 'ilbieraħ',
    on: 'nhar',
    at: 'fis-',
    underCredits: 'inqas minn 0.1 kreditu',
    credit: 'kreditu',
    credits: 'krediti',
    took: 'Dam {duration}{used}',
    andUsed: 'u uża {credits}',
    versionLabel: 'Verżjoni {version}',
    draftRevision: 'L-abbozz, reviżjoni {version}',
    following: 'wara {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 's',
    statusQueued: 'Fil-kju',
    statusRunning: 'Għaddej',
    statusApproval: 'Jeħtieġ approvazzjoni',
    statusDone: 'Lest',
    statusFailed: 'Falla',
    statusCancelled: 'Ikkanċellat',
    loadingWorkspace: 'Qed jitgħabba l-ispazju tax-xogħol tiegħek…',
    knowledgeErrorRevision_conflict: 'Din il-paġna nbidlet waqt li kont qed taħdem fuqha.',
    knowledgeErrorSuggestion_outdated:
      'It-test li jbiddel dan is-suġġeriment ġie editjat minn dak iż-żmien. Issa jista’ biss jiġi rrifjutat jew irtirat.',
  },
  pl: {
    justNow: 'przed chwilą',
    editedBy: 'edytowane przez {name}',
    imported: 'zaimportowano',
    acceptedBy: 'zaakceptowano przez {name}',
    acceptedPoneva: 'Zaakceptowano sugestię Poneva',
    acceptedFrom: 'Zaakceptowano sugestię od {name}',
    acceptedNamed: 'Zaakceptowano sugestię {name}',
    acceptedSuggestion: 'Zaakceptowano sugestię',
    fromMeeting: 'Ze spotkania',
    inYourChat: 'Na Twoim czacie',
    inNamedChat: 'Na czacie {name}',
    inAChat: 'Na czacie',
    connectedAgent: 'Połączony agent',
    connectedAgentFor: 'Połączony agent dla {name}',
    repositoryImport: 'Import repozytorium',
    importedText: 'Zaimportowany tekst',
    you: 'Ty',
    colleague: 'Współpracownik',
    editedPage: 'Edytowano stronę',
    suggestedNewPage: 'Zasugerowano nową stronę',
    suggestedMove: 'Zasugerowano przeniesienie',
    suggestedArchive: 'Zasugerowano archiwizację',
    saved: 'Zapisano',
    noTextYet: 'Brak tekstu',
    openSuggestion: 'one:otwarta sugestia|other:otwarte sugestie',
    suggestion: 'one:sugestia|other:sugestie',
    archivedPage: 'one:zarchiwizowana strona|other:zarchiwizowane strony',
    character: 'one:znak|other:znaki',
    runQueued: 'Oczekiwanie na uruchomienie',
    runRunning: 'Nadal trwa',
    runApproval: 'Oczekiwanie na zatwierdzenie na tym czacie',
    runCancelled: 'Zatrzymano przed ukończeniem',
    runFinished: 'Ukończono.',
    runSavedResult: 'Zapisano wynik.',
    runCouldNotRead: 'Nie udało się odczytać: {sources}.',
    runScheduled: 'Zaplanowano',
    runBy: 'Uruchomione przez {name}',
    testRunBy: 'Uruchomienie testowe przez {name}',
    formerMember: 'były członek',
    youLower: 'Ty',
    colleagueLower: 'współpracownik',
    missedTime: 'raz',
    missedTimes: 'razy',
    runs: 'Uruchomienia',
    openRunChat: 'Otwórz czat uruchomienia',
    watch: 'Obserwuj',
    cancel: 'Anuluj',
    noRuns: 'Brak uruchomień.',
    skill: 'Umiejętność',
    skillPublished: 'Agent zawsze korzysta z opublikowanej wersji umiejętności.',
    whenRuns: 'Kiedy jest uruchamiana',
    day: 'Dzień',
    time: 'Godzina',
    cron: 'Wyrażenie Cron',
    notPublished: '· nieopublikowana',
    version: '· wersja {version}',
    today: 'dzisiaj',
    tomorrow: 'jutro',
    yesterday: 'wczoraj',
    on: 'dnia',
    at: 'o',
    underCredits: 'poniżej 0,1 kredytu',
    credit: 'kredyt',
    credits: 'kredyty',
    took: 'Zajęło {duration}{used}',
    andUsed: 'i wykorzystano {credits}',
    versionLabel: 'Wersja {version}',
    draftRevision: 'Wersja robocza, rewizja {version}',
    following: 'następujące: {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'godz.',
    statusQueued: 'W kolejce',
    statusRunning: 'W toku',
    statusApproval: 'Wymaga zatwierdzenia',
    statusDone: 'Gotowe',
    statusFailed: 'Niepowodzenie',
    statusCancelled: 'Anulowano',
    loadingWorkspace: 'Ładowanie Twojego obszaru roboczego…',
    knowledgeErrorRevision_conflict: 'Ta strona zmieniła się podczas Twojej pracy.',
    knowledgeErrorSuggestion_outdated:
      'Tekst, który zmienia ta sugestia, został od tego czasu zedytowany. Można ją teraz tylko odrzucić lub wycofać.',
    knowledgeErrorSuggestion_reason_required: 'Napisz krótko, dlaczego ta zmiana jest właściwa.',
    knowledgeErrorSuggestion_no_change: 'Ta zmiana nie wpłynie na stronę.',
    knowledgeErrorSuggestion_markdown_required: 'Proponowana nowa strona musi zawierać tekst.',
    knowledgeErrorCompany_publish_required: 'Tylko wydawcy firmowi mogą akceptować zmiany.',
    knowledgeErrorKnowledge_proposal_limit:
      'Twoja firma ma już 200 sugestii oczekujących na sprawdzenie. Zanim dodasz kolejne, przejrzyj część z nich.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Masz już 50 sugestii oczekujących na decyzję. Poczekaj, aż część z nich zostanie rozpatrzona, albo wycofaj niektóre z nich, zanim dodasz kolejne.',
    knowledgeErrorKnowledge_page_too_large:
      'Strona ma więcej niż 256 KB. Podziel ją na mniejsze strony.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Strona ma więcej niż 2000 nagłówków. Podziel ją na mniejsze strony.',
    knowledgeErrorKnowledge_page_limit: 'Twoja firma osiągnęła limit 2000 stron wiedzy.',
    knowledgeErrorKnowledge_page_archived: 'Ta strona jest zarchiwizowana.',
    knowledgeErrorKnowledge_page_has_children:
      'Najpierw przenieś lub zarchiwizuj strony znajdujące się pod tą stroną.',
    knowledgeErrorKnowledge_page_delete_children:
      'Najpierw przywróć lub usuń strony znajdujące się pod tą stroną.',
    knowledgeErrorKnowledge_page_not_archived:
      'Tylko zarchiwizowaną stronę można przywrócić lub usunąć.',
    knowledgeErrorKnowledge_root_page:
      'Strony z przeglądem firmy nie można przenosić ani archiwizować.',
    knowledgeErrorKnowledge_page_cycle:
      'Nie można przenieść strony pod samą siebie ani pod jedną z jej podstron.',
    knowledgeErrorKnowledge_parent_not_found: 'Ta strona nie jest już dostępna.',
    knowledgeErrorKnowledge_parent_archived: 'Ta strona jest zarchiwizowana. Wybierz inną.',
    knowledgeErrorKnowledge_page_not_found: 'Ta strona nie jest już dostępna.',
    knowledgeErrorKnowledge_proposal_not_found: 'Ta sugestia nie jest już dla Ciebie dostępna.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Tylko osoba, która dodała tę sugestię, może ją wycofać.',
    knowledgeErrorProposal_not_pending: 'Ta sugestia została już rozpatrzona.',
    knowledgeErrorProposal_requester_removed:
      'Osoba, która dodała tę sugestię, nie należy już do tej firmy, dlatego nie można jej zaakceptować.',
    knowledgeErrorPage_archived:
      'Ta strona została zarchiwizowana. Zaakceptowanie tej sugestii ją przywróci — najpierw sprawdź ją ponownie.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva nie mogła zaakceptować tych danych. Sprawdź pola i spróbuj ponownie.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Strony wiedzy są teraz niedostępne. Spróbuj ponownie.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva zbyt długo nie odpowiadała. Spróbuj ponownie.',
    agentErrorAgent_unpublished: 'Opublikuj wersję przed uruchomieniem tego agenta.',
    agentErrorAgent_revision_conflict:
      'Ktoś inny zmienił tego agenta. Wczytaj go ponownie przed zapisaniem zmian.',
    agentErrorAgent_run_queue_full:
      'Ten agent ma już kilka oczekujących uruchomień. Spróbuj ponownie za chwilę.',
    agentErrorPublished_skill_required: 'Wybierz opublikowaną umiejętność, której możesz użyć.',
    agentErrorInvalid_schedule:
      'Nie udało się odczytać tego harmonogramu. Sprawdź godzinę lub wyrażenie cron.',
    agentErrorSchedule_too_frequent: 'Agent może uruchamiać się najwyżej co 15 minut.',
    agentErrorAgent_edit_access_exists: 'Masz już możliwość edytowania tego agenta.',
    agentErrorAgent_forbidden: 'Nie możesz zmieniać tego agenta.',
    agentErrorAgent_has_no_owner:
      'Jego właściciel odszedł, więc agent należy do firmy i pozostaje agentem firmowym. Zamiast tego wyłącz go lub zarchiwizuj.',
    agentErrorAgent_not_found: 'Ten agent nie jest już dla Ciebie dostępny.',
    agentErrorAgent_instructions_required: 'Dodaj instrukcje albo najpierw przypnij umiejętność.',
    toolbarBulletedList: 'Lista punktowana',
    toolbarNumberedList: 'Lista numerowana',
    toolbarWebLink: 'Link internetowy',
    agentErrorGeneric: 'Nie udało się zrealizować tego żądania.',
  },
  pt: {
    knowledgeErrorSuggestion_reason_required:
      'Explique brevemente por que essa alteração está correta.',
    knowledgeErrorSuggestion_no_change: 'Isso não alteraria a página.',
    knowledgeErrorSuggestion_markdown_required: 'Uma nova página sugerida precisa de algum texto.',
    knowledgeErrorCompany_publish_required:
      'Somente publicadores da empresa podem aceitar alterações.',
    knowledgeErrorKnowledge_proposal_limit:
      'Sua empresa já tem 200 sugestões aguardando revisão. Revise algumas antes de sugerir mais.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Você já tem 50 sugestões aguardando revisão. Aguarde até que algumas sejam decididas ou retire algumas antes de sugerir mais.',
    knowledgeErrorKnowledge_page_too_large:
      'Uma página tem mais de 256 KB. Divida-a em páginas menores.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Uma página tem mais de 2.000 títulos. Divida-a em páginas menores.',
    knowledgeErrorKnowledge_page_limit:
      'Sua empresa atingiu o limite de 2.000 páginas de conhecimento.',
    knowledgeErrorKnowledge_page_archived: 'Esta página está arquivada.',
    knowledgeErrorKnowledge_page_has_children:
      'Mova ou arquive primeiro as páginas sob esta página.',
    knowledgeErrorKnowledge_page_delete_children:
      'Restaure ou exclua primeiro as páginas sob esta página.',
    knowledgeErrorKnowledge_page_not_archived:
      'Somente uma página arquivada pode ser restaurada ou excluída.',
    knowledgeErrorKnowledge_root_page:
      'A página de visão geral da empresa não pode ser movida nem arquivada.',
    knowledgeErrorKnowledge_page_cycle:
      'Uma página não pode ser movida para dentro dela mesma ou de uma de suas próprias páginas.',
    knowledgeErrorKnowledge_parent_not_found: 'Essa página não está mais disponível.',
    knowledgeErrorKnowledge_parent_archived: 'Essa página está arquivada. Escolha outra.',
    knowledgeErrorKnowledge_page_not_found: 'Esta página não está mais disponível.',
    knowledgeErrorKnowledge_proposal_not_found: 'Esta sugestão não está mais disponível para você.',
    knowledgeErrorKnowledge_proposal_forbidden: 'Somente quem fez a sugestão pode retirá-la.',
    knowledgeErrorProposal_not_pending: 'Esta sugestão já foi decidida.',
    knowledgeErrorProposal_requester_removed:
      'Quem fez a sugestão não está mais nesta empresa, então ela não pode ser aceita.',
    knowledgeErrorPage_archived:
      'Esta página foi arquivada. Aceitar esta sugestão fará com que ela volte a ficar disponível; revise-a novamente antes.',
    knowledgeErrorInvalid_knowledge_page_input:
      'O Poneva não conseguiu aceitar esta entrada. Verifique os campos e tente novamente.',
    knowledgeErrorKnowledge_pages_unavailable:
      'As páginas de conhecimento estão indisponíveis no momento. Tente novamente.',
    knowledgeErrorKnowledge_pages_timeout:
      'O Poneva demorou demais para responder. Tente novamente.',
    agentErrorAgent_unpublished: 'Publique uma versão antes de executar este agente.',
    agentErrorAgent_revision_conflict:
      'Outra pessoa alterou este agente. Recarregue-o antes de salvá-lo novamente.',
    agentErrorAgent_run_queue_full:
      'Este agente já tem várias execuções aguardando. Tente novamente em instantes.',
    agentErrorPublished_skill_required: 'Escolha uma habilidade publicada que você possa usar.',
    agentErrorInvalid_schedule:
      'Não foi possível ler essa programação. Verifique o horário ou a expressão cron.',
    agentErrorSchedule_too_frequent: 'Um agente pode ser executado no máximo a cada 15 minutos.',
    agentErrorAgent_edit_access_exists: 'Você já pode editar este agente.',
    agentErrorAgent_forbidden: 'Você não pode alterar este agente.',
    agentErrorAgent_has_no_owner:
      'O responsável saiu, então ele pertence à empresa e continua sendo um agente da empresa. Desative-o ou arquive-o.',
    agentErrorAgent_not_found: 'Este agente não está mais disponível para você.',
    agentErrorAgent_instructions_required: 'Dê instruções a ele ou fixe uma habilidade primeiro.',
    toolbarBulletedList: 'Lista com marcadores',
    toolbarNumberedList: 'Lista numerada',
    toolbarWebLink: 'Link da web',
    agentErrorGeneric: 'Não foi possível concluir esta solicitação.',
    justNow: 'agora mesmo',
    editedBy: 'editado por {name}',
    imported: 'importado',
    acceptedBy: 'aceito por {name}',
    acceptedPoneva: 'Sugestão da Poneva aceita',
    acceptedFrom: 'Sugestão de {name} aceita',
    acceptedNamed: 'Sugestão de {name} aceita',
    acceptedSuggestion: 'Sugestão aceita',
    fromMeeting: 'Da reunião',
    inYourChat: 'No seu chat',
    inNamedChat: 'No chat de {name}',
    inAChat: 'Em um chat',
    connectedAgent: 'Agente conectado',
    connectedAgentFor: 'Agente conectado para {name}',
    repositoryImport: 'Importação do repositório',
    importedText: 'Texto importado',
    you: 'Você',
    colleague: 'Um colega',
    editedPage: 'Página editada',
    suggestedNewPage: 'Sugeriu uma nova página',
    suggestedMove: 'Sugeriu uma movimentação',
    suggestedArchive: 'Sugeriu arquivamento',
    saved: 'Salvo',
    noTextYet: 'Nenhum texto ainda',
    openSuggestion: 'one:abrir sugestão|other:abrir sugestões',
    suggestion: 'one:sugestão|other:sugestões',
    archivedPage: 'one:página arquivada|other:páginas arquivadas',
    character: 'one:caractere|other:caracteres',
    runQueued: 'Aguardando início',
    runRunning: 'Ainda em execução',
    runApproval: 'Aguardando aprovação neste chat',
    runCancelled: 'Interrompido antes de terminar',
    runFinished: 'Concluído.',
    runSavedResult: 'Resultado salvo.',
    runCouldNotRead: 'Não foi possível ler: {sources}.',
    runScheduled: 'Agendado',
    runBy: 'Executado por {name}',
    testRunBy: 'Execução de teste por {name}',
    formerMember: 'um ex-membro',
    youLower: 'você',
    colleagueLower: 'um colega',
    missedTime: 'vez',
    missedTimes: 'vezes',
    runs: 'Execuções',
    openRunChat: 'Abrir o chat da execução',
    watch: 'Acompanhar',
    cancel: 'Cancelar',
    noRuns: 'Nenhuma execução ainda.',
    skill: 'Habilidade',
    skillPublished: 'O agente sempre usa a versão publicada da habilidade.',
    whenRuns: 'Quando é executada',
    day: 'Dia',
    time: 'Horário',
    cron: 'Expressão cron',
    notPublished: '· não publicada',
    version: '· versão {version}',
    today: 'hoje',
    tomorrow: 'amanhã',
    yesterday: 'ontem',
    on: 'em',
    at: 'às',
    underCredits: 'menos de 0,1 crédito',
    credit: 'crédito',
    credits: 'créditos',
    took: 'Levou {duration}{used}',
    andUsed: 'e usou {credits}',
    versionLabel: 'Versão {version}',
    draftRevision: 'O rascunho, revisão {version}',
    following: 'seguindo {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Na fila',
    statusRunning: 'Em execução',
    statusApproval: 'Requer aprovação',
    statusDone: 'Concluído',
    statusFailed: 'Falhou',
    statusCancelled: 'Cancelado',
    loadingWorkspace: 'Carregando seu espaço de trabalho…',
    knowledgeErrorRevision_conflict: 'Esta página foi alterada enquanto você trabalhava nela.',
    knowledgeErrorSuggestion_outdated:
      'O texto alterado por esta sugestão foi editado desde então. Agora, ela só pode ser rejeitada ou retirada.',
  },
  ro: {
    knowledgeErrorSuggestion_reason_required:
      'Spuneți în câteva cuvinte de ce este corectă această modificare.',
    knowledgeErrorSuggestion_no_change: 'Aceasta nu ar modifica pagina.',
    knowledgeErrorSuggestion_markdown_required: 'O pagină nouă sugerată trebuie să conțină text.',
    knowledgeErrorCompany_publish_required: 'Doar editorii companiei pot accepta modificări.',
    knowledgeErrorKnowledge_proposal_limit:
      'Compania dvs. are deja 200 de sugestii în așteptarea examinării. Examinați câteva înainte de a sugera altele.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Aveți deja 50 de sugestii în așteptarea examinării. Așteptați până când unele primesc o decizie sau retrageți câteva înainte de a sugera altele.',
    knowledgeErrorKnowledge_page_too_large:
      'O pagină depășește 256 KB. Împărțiți-o în pagini mai mici.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'O pagină are peste 2.000 de titluri. Împărțiți-o în pagini mai mici.',
    knowledgeErrorKnowledge_page_limit:
      'Compania dvs. a atins limita de 2.000 de pagini de cunoștințe.',
    knowledgeErrorKnowledge_page_archived: 'Această pagină este arhivată.',
    knowledgeErrorKnowledge_page_has_children:
      'Mutați sau arhivați mai întâi paginile aflate sub aceasta.',
    knowledgeErrorKnowledge_page_delete_children:
      'Restaurați sau ștergeți mai întâi paginile aflate sub aceasta.',
    knowledgeErrorKnowledge_page_not_archived:
      'Doar o pagină arhivată poate fi restaurată sau ștearsă.',
    knowledgeErrorKnowledge_root_page:
      'Pagina de prezentare a companiei nu poate fi mutată sau arhivată.',
    knowledgeErrorKnowledge_page_cycle:
      'O pagină nu poate fi mutată sub ea însăși sau sub una dintre propriile pagini.',
    knowledgeErrorKnowledge_parent_not_found: 'Pagina respectivă nu mai este disponibilă.',
    knowledgeErrorKnowledge_parent_archived: 'Pagina respectivă este arhivată. Alegeți alta.',
    knowledgeErrorKnowledge_page_not_found: 'Această pagină nu mai este disponibilă.',
    knowledgeErrorKnowledge_proposal_not_found: 'Această sugestie nu vă mai este disponibilă.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Doar persoana care a făcut sugestia o poate retrage.',
    knowledgeErrorProposal_not_pending: 'Această sugestie a primit deja o decizie.',
    knowledgeErrorProposal_requester_removed:
      'Persoana care a făcut sugestia nu mai face parte din această companie, așadar aceasta nu poate fi acceptată.',
    knowledgeErrorPage_archived:
      'Această pagină a fost arhivată. Acceptarea acestei sugestii o readuce, dar examinați-o din nou mai întâi.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva nu a putut accepta aceste date. Verificați câmpurile și încercați din nou.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Paginile de cunoștințe nu sunt disponibile momentan. Încercați din nou.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva a avut nevoie de prea mult timp pentru a răspunde. Încercați din nou.',
    agentErrorAgent_unpublished: 'Publicați o versiune înainte de a rula acest agent.',
    agentErrorAgent_revision_conflict:
      'Altcineva a modificat acest agent. Reîncărcați-l înainte de a salva din nou.',
    agentErrorAgent_run_queue_full:
      'Acest agent are deja mai multe rulări în așteptare. Încercați din nou peste un moment.',
    agentErrorPublished_skill_required: 'Alegeți o Skill publicată pe care o puteți folosi.',
    agentErrorInvalid_schedule:
      'Programul respectiv nu a putut fi citit. Verificați ora sau expresia cron.',
    agentErrorSchedule_too_frequent: 'Un agent poate rula cel mult o dată la 15 minute.',
    agentErrorAgent_edit_access_exists: 'Aveți deja drepturi de editare pentru acest agent.',
    agentErrorAgent_forbidden: 'Nu puteți modifica acest agent.',
    agentErrorAgent_has_no_owner:
      'Proprietarul său a plecat, așa că agentul aparține companiei și rămâne un agent al companiei. Dezactivați-l sau arhivați-l.',
    agentErrorAgent_not_found: 'Acest agent nu vă mai este disponibil.',
    agentErrorAgent_instructions_required: 'Adăugați instrucțiuni sau fixați mai întâi o Skill.',
    toolbarBulletedList: 'Listă cu marcatori',
    toolbarNumberedList: 'Listă numerotată',
    toolbarWebLink: 'Link web',
    agentErrorGeneric: 'Nu am putut finaliza această solicitare.',
    justNow: 'chiar acum',
    editedBy: 'editat de {name}',
    imported: 'importat',
    acceptedBy: 'acceptat de {name}',
    acceptedPoneva: 'Sugestia Poneva a fost acceptată',
    acceptedFrom: 'A acceptat o sugestie de la {name}',
    acceptedNamed: 'A acceptat sugestia lui {name}',
    acceptedSuggestion: 'A acceptat o sugestie',
    fromMeeting: 'Din ședință',
    inYourChat: 'În conversația ta',
    inNamedChat: 'În conversația lui {name}',
    inAChat: 'Într-o conversație',
    connectedAgent: 'Un agent conectat',
    connectedAgentFor: 'Agent conectat pentru {name}',
    repositoryImport: 'Import de depozit',
    importedText: 'Text importat',
    you: 'Tu',
    colleague: 'Un coleg',
    editedPage: 'A editat pagina',
    suggestedNewPage: 'A sugerat o pagină nouă',
    suggestedMove: 'A sugerat o mutare',
    suggestedArchive: 'A sugerat arhivarea',
    saved: 'Salvat',
    noTextYet: 'Încă nu există text',
    openSuggestion: 'one:sugestie deschisă|other:sugestii deschise',
    suggestion: 'one:sugestie|other:sugestii',
    archivedPage: 'one:pagină arhivată|other:pagini arhivate',
    character: 'one:caracter|other:caractere',
    runQueued: 'În așteptarea pornirii',
    runRunning: 'Încă rulează',
    runApproval: 'În așteptarea unei aprobări în această conversație',
    runCancelled: 'Oprit înainte de finalizare',
    runFinished: 'Finalizat.',
    runSavedResult: 'Rezultat salvat.',
    runCouldNotRead: 'Nu s-a putut citi: {sources}.',
    runScheduled: 'Programat',
    runBy: 'Rulat de {name}',
    testRunBy: 'Rulare de test realizată de {name}',
    formerMember: 'un fost membru',
    youLower: 'tu',
    colleagueLower: 'un coleg',
    missedTime: 'dată',
    missedTimes: 'dăți',
    runs: 'Rulări',
    openRunChat: 'Deschide conversația rulării',
    watch: 'Urmărește',
    cancel: 'Anulează',
    noRuns: 'Încă nu există rulări.',
    skill: 'Abilitate',
    skillPublished: 'Agentul folosește întotdeauna versiunea publicată a abilității.',
    whenRuns: 'Când rulează',
    day: 'Zi',
    time: 'Ora',
    cron: 'Expresie cron',
    notPublished: '· nepublicată',
    version: '· versiunea {version}',
    today: 'astăzi',
    tomorrow: 'mâine',
    yesterday: 'ieri',
    on: 'pe',
    at: 'la',
    underCredits: 'sub 0,1 credite',
    credit: 'credit',
    credits: 'credite',
    took: 'A durat {duration}{used}',
    andUsed: 'și a folosit {credits}',
    versionLabel: 'Versiunea {version}',
    draftRevision: 'Ciorna, revizia {version}',
    following: 'urmând {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'În coadă',
    statusRunning: 'Rulează',
    statusApproval: 'Necesită aprobare',
    statusDone: 'Finalizat',
    statusFailed: 'Eșuat',
    statusCancelled: 'Anulat',
    loadingWorkspace: 'Se încarcă spațiul de lucru…',
    knowledgeErrorRevision_conflict: 'Pagina s-a modificat în timp ce lucrai la ea.',
    knowledgeErrorSuggestion_outdated:
      'Textul modificat de această sugestie a fost editat între timp. Acum poate fi doar respinsă sau retrasă.',
  },
  sk: {
    justNow: 'práve teraz',
    editedBy: 'upravil(a) {name}',
    imported: 'importované',
    acceptedBy: 'prijal(a) {name}',
    acceptedPoneva: 'Prijatý návrh od Poneva',
    acceptedFrom: 'Prijatý návrh od {name}',
    acceptedNamed: 'Prijatý návrh od {name}',
    acceptedSuggestion: 'Prijatý návrh',
    fromMeeting: 'Zo schôdze',
    inYourChat: 'Vo vašom chate',
    inNamedChat: 'V chate používateľa {name}',
    inAChat: 'V chate',
    connectedAgent: 'Pripojený agent',
    connectedAgentFor: 'Pripojený agent pre {name}',
    repositoryImport: 'Import repozitára',
    importedText: 'Importovaný text',
    you: 'Vy',
    colleague: 'Kolega',
    editedPage: 'Upravil(a) stránku',
    suggestedNewPage: 'Navrhol(a) novú stránku',
    suggestedMove: 'Navrhol(a) presunutie',
    suggestedArchive: 'Navrhol(a) archiváciu',
    saved: 'Uložené',
    noTextYet: 'Zatiaľ žiadny text',
    openSuggestion: 'one:otvorený návrh|other:otvorené návrhy',
    suggestion: 'one:návrh|other:návrhy',
    archivedPage: 'one:archivovaná stránka|other:archivované stránky',
    character: 'one:znak|other:znaky',
    runQueued: 'Čaká na spustenie',
    runRunning: 'Stále prebieha',
    runApproval: 'Čaká na schválenie v tomto chate',
    runCancelled: 'Zastavené pred dokončením',
    runFinished: 'Dokončené.',
    runSavedResult: 'Výsledok uložený.',
    runCouldNotRead: 'Nepodarilo sa prečítať: {sources}.',
    runScheduled: 'Naplánované',
    runBy: 'Spustil(a) {name}',
    testRunBy: 'Test spustil(a) {name}',
    formerMember: 'bývalý člen',
    youLower: 'vy',
    colleagueLower: 'kolega',
    missedTime: 'raz',
    missedTimes: 'krát',
    runs: 'Spustenia',
    openRunChat: 'Otvoriť chat spustenia',
    watch: 'Sledovať',
    cancel: 'Zrušiť',
    noRuns: 'Zatiaľ žiadne spustenia.',
    skill: 'Zručnosť',
    skillPublished: 'Agent vždy používa publikovanú verziu zručnosti.',
    whenRuns: 'Kedy sa spúšťa',
    day: 'Deň',
    time: 'Čas',
    cron: 'Výraz Cron',
    notPublished: '· nepublikované',
    version: '· verzia {version}',
    today: 'dnes',
    tomorrow: 'zajtra',
    yesterday: 'včera',
    on: 'v',
    at: 'o',
    underCredits: 'menej ako 0,1 kreditov',
    credit: 'kredit',
    credits: 'kredity',
    took: 'Trvalo {duration}{used}',
    andUsed: 'a spotrebovalo sa {credits}',
    versionLabel: 'Verzia {version}',
    draftRevision: 'Koncept, revízia {version}',
    following: 'nasledujúce: {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Vo fronte',
    statusRunning: 'Prebieha',
    statusApproval: 'Vyžaduje schválenie',
    statusDone: 'Hotovo',
    statusFailed: 'Zlyhalo',
    statusCancelled: 'Zrušené',
    loadingWorkspace: 'Načítava sa váš pracovný priestor…',
    knowledgeErrorRevision_conflict: 'Táto stránka sa počas vašej práce zmenila.',
    knowledgeErrorSuggestion_outdated:
      'Text, ktorý tento návrh mení, bol odvtedy upravený. Návrh možno už len zamietnuť alebo odvolať.',
    knowledgeErrorSuggestion_reason_required: 'Stručne vysvetlite, prečo je táto zmena správna.',
    knowledgeErrorSuggestion_no_change: 'Týmto sa stránka nezmení.',
    knowledgeErrorSuggestion_markdown_required: 'Navrhovaná nová stránka musí obsahovať text.',
    knowledgeErrorCompany_publish_required: 'Zmeny môžu prijímať iba firemní vydavatelia.',
    knowledgeErrorKnowledge_proposal_limit:
      'Vaša firma už má 200 návrhov čakajúcich na kontrolu. Pred odoslaním ďalších niektoré skontrolujte.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Už máte 50 návrhov čakajúcich na rozhodnutie. Pred odoslaním ďalších počkajte, kým sa o niektorých nerozhodne, alebo niektoré stiahnite.',
    knowledgeErrorKnowledge_page_too_large:
      'Stránka je väčšia než 256 KB. Rozdeľte ju na menšie stránky.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Stránka obsahuje viac než 2 000 nadpisov. Rozdeľte ju na menšie stránky.',
    knowledgeErrorKnowledge_page_limit: 'Vaša firma dosiahla limit 2 000 stránok znalostí.',
    knowledgeErrorKnowledge_page_archived: 'Táto stránka je archivovaná.',
    knowledgeErrorKnowledge_page_has_children:
      'Najskôr presuňte alebo archivujte stránky pod touto stránkou.',
    knowledgeErrorKnowledge_page_delete_children:
      'Najskôr obnovte alebo odstráňte stránky pod touto stránkou.',
    knowledgeErrorKnowledge_page_not_archived:
      'Obnoviť alebo odstrániť možno iba archivovanú stránku.',
    knowledgeErrorKnowledge_root_page: 'Stránku s prehľadom firmy nemožno presunúť ani archivovať.',
    knowledgeErrorKnowledge_page_cycle:
      'Stránku nemožno presunúť pod ňu samotnú ani pod jednu z jej vlastných stránok.',
    knowledgeErrorKnowledge_parent_not_found: 'Táto stránka už nie je k dispozícii.',
    knowledgeErrorKnowledge_parent_archived: 'Táto stránka je archivovaná. Vyberte inú.',
    knowledgeErrorKnowledge_page_not_found: 'Táto stránka už nie je k dispozícii.',
    knowledgeErrorKnowledge_proposal_not_found: 'Tento návrh už pre vás nie je k dispozícii.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Tento návrh môže stiahnuť iba osoba, ktorá ho odoslala.',
    knowledgeErrorProposal_not_pending: 'O tomto návrhu už bolo rozhodnuté.',
    knowledgeErrorProposal_requester_removed:
      'Osoba, ktorá tento návrh odoslala, už nie je v tejto firme, preto ho nemožno prijať.',
    knowledgeErrorPage_archived:
      'Táto stránka bola archivovaná. Prijatím tohto návrhu sa obnoví, preto ju najskôr znova skontrolujte.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva nemohla prijať tieto údaje. Skontrolujte polia a skúste to znova.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Stránky znalostí momentálne nie sú k dispozícii. Skúste to znova.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva odpovedala príliš dlho. Skúste to znova.',
    agentErrorAgent_unpublished: 'Pred spustením tohto agenta publikujte jeho verziu.',
    agentErrorAgent_revision_conflict:
      'Tento agent zmenil niekto iný. Pred ďalším uložením ho znova načítajte.',
    agentErrorAgent_run_queue_full:
      'Tento agent už má niekoľko spustení vo fronte. Skúste to znova o chvíľu.',
    agentErrorPublished_skill_required: 'Vyberte publikovanú zručnosť, ktorú môžete použiť.',
    agentErrorInvalid_schedule:
      'Tento rozvrh sa nepodarilo prečítať. Skontrolujte čas alebo výraz cron.',
    agentErrorSchedule_too_frequent: 'Agent sa môže spúšťať najviac každých 15 minút.',
    agentErrorAgent_edit_access_exists: 'Tohto agenta už môžete upravovať.',
    agentErrorAgent_forbidden: 'Tohto agenta nemôžete meniť.',
    agentErrorAgent_has_no_owner:
      'Jeho vlastník odišiel, preto patrí firme a zostáva firemným agentom. Namiesto toho ho vypnite alebo archivujte.',
    agentErrorAgent_not_found: 'Tento agent už pre vás nie je k dispozícii.',
    agentErrorAgent_instructions_required: 'Zadajte mu pokyny alebo najskôr pripnite zručnosť.',
    toolbarBulletedList: 'Zoznam s odrážkami',
    toolbarNumberedList: 'Číslovaný zoznam',
    toolbarWebLink: 'Webový odkaz',
    agentErrorGeneric: 'Túto požiadavku sa nepodarilo dokončiť.',
  },
  sl: {
    knowledgeErrorSuggestion_reason_required: 'Na kratko povejte, zakaj je ta sprememba ustrezna.',
    knowledgeErrorSuggestion_no_change: 'To ne bi spremenilo strani.',
    knowledgeErrorSuggestion_markdown_required: 'Predlagana nova stran potrebuje nekaj besedila.',
    knowledgeErrorCompany_publish_required: 'Spremembe lahko sprejmejo samo objavitelji podjetja.',
    knowledgeErrorKnowledge_proposal_limit:
      'Vaše podjetje že ima 200 predlogov, ki čakajo na pregled. Predlagajte nove šele, ko jih nekaj pregledate.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Že imate 50 predlogov, ki čakajo na pregled. Počakajte, da bodo nekateri obravnavani, ali jih nekaj umaknite, preden predlagate nove.',
    knowledgeErrorKnowledge_page_too_large:
      'Stran je večja od 256 KB. Razdelite jo na manjše strani.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Stran ima več kot 2.000 naslovov. Razdelite jo na manjše strani.',
    knowledgeErrorKnowledge_page_limit: 'Vaše podjetje je doseglo omejitev 2.000 strani znanja.',
    knowledgeErrorKnowledge_page_archived: 'Ta stran je arhivirana.',
    knowledgeErrorKnowledge_page_has_children:
      'Najprej premaknite ali arhivirajte strani pod to stranjo.',
    knowledgeErrorKnowledge_page_delete_children:
      'Najprej obnovite ali izbrišite strani pod to stranjo.',
    knowledgeErrorKnowledge_page_not_archived:
      'Obnovite ali izbrišete lahko samo arhivirano stran.',
    knowledgeErrorKnowledge_root_page:
      'Pregledne strani podjetja ni mogoče premakniti ali arhivirati.',
    knowledgeErrorKnowledge_page_cycle:
      'Strani ni mogoče premakniti pod samo sebe ali pod eno od svojih podstrani.',
    knowledgeErrorKnowledge_parent_not_found: 'Ta stran ni več na voljo.',
    knowledgeErrorKnowledge_parent_archived: 'Ta stran je arhivirana. Izberite drugo.',
    knowledgeErrorKnowledge_page_not_found: 'Ta stran ni več na voljo.',
    knowledgeErrorKnowledge_proposal_not_found: 'Ta predlog vam ni več na voljo.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Ta predlog lahko umakne samo oseba, ki ga je predlagala.',
    knowledgeErrorProposal_not_pending: 'Ta predlog je že bil obravnavan.',
    knowledgeErrorProposal_requester_removed:
      'Oseba, ki je to predlagala, ni več v tem podjetju, zato predloga ni mogoče sprejeti.',
    knowledgeErrorPage_archived:
      'Ta stran je bila arhivirana. Če sprejmete ta predlog, se bo obnovila; najprej ga znova preglejte.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva tega vnosa ni mogla sprejeti. Preverite polja in poskusite znova.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Strani znanja trenutno niso na voljo. Poskusite znova.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva je za odgovor potrebovala predolgo. Poskusite znova.',
    agentErrorAgent_unpublished: 'Pred zagonom tega agenta objavite različico.',
    agentErrorAgent_revision_conflict:
      'Ta agent je medtem spremenil nekdo drug. Pred ponovnim shranjevanjem ga znova naložite.',
    agentErrorAgent_run_queue_full:
      'Ta agent ima že več izvajanj na čakanju. Čez trenutek poskusite znova.',
    agentErrorPublished_skill_required: 'Izberite objavljeno veščino, ki jo lahko uporabite.',
    agentErrorInvalid_schedule:
      'Tega urnika ni bilo mogoče prebrati. Preverite čas ali izraz cron.',
    agentErrorSchedule_too_frequent: 'Agent se lahko zažene največ vsakih 15 minut.',
    agentErrorAgent_edit_access_exists: 'Tega agenta lahko že urejate.',
    agentErrorAgent_forbidden: 'Tega agenta ne morete spreminjati.',
    agentErrorAgent_has_no_owner:
      'Njegov lastnik je zapustil podjetje, zato pripada podjetju in ostane agent podjetja. Namesto tega ga izklopite ali arhivirajte.',
    agentErrorAgent_not_found: 'Ta agent vam ni več na voljo.',
    agentErrorAgent_instructions_required: 'Dodajte mu navodila ali najprej pripnite veščino.',
    toolbarBulletedList: 'Označeni seznam',
    toolbarNumberedList: 'Oštevilčeni seznam',
    toolbarWebLink: 'Spletna povezava',
    agentErrorGeneric: 'Te zahteve ni bilo mogoče dokončati.',
    justNow: 'pravkar',
    editedBy: 'uredil/-a {name}',
    imported: 'uvoženo',
    acceptedBy: 'sprejel/-a {name}',
    acceptedPoneva: 'Sprejet Ponevin predlog',
    acceptedFrom: 'Sprejet predlog uporabnika {name}',
    acceptedNamed: 'Sprejet predlog uporabnika {name}',
    acceptedSuggestion: 'Sprejet predlog',
    fromMeeting: 'S sestanka',
    inYourChat: 'V vašem klepetu',
    inNamedChat: 'V klepetu uporabnika {name}',
    inAChat: 'V klepetu',
    connectedAgent: 'Povezani agent',
    connectedAgentFor: 'Povezani agent za {name}',
    repositoryImport: 'Uvoz repozitorija',
    importedText: 'Uvoženo besedilo',
    you: 'Vi',
    colleague: 'Sodelavec',
    editedPage: 'Urejena stran',
    suggestedNewPage: 'Predlagana nova stran',
    suggestedMove: 'Predlagana premestitev',
    suggestedArchive: 'Predlagano arhiviranje',
    saved: 'Shranjeno',
    noTextYet: 'Besedila še ni',
    openSuggestion: 'one:odpri predlog|other:odpri predloge',
    suggestion: 'one:predlog|other:predlogi',
    archivedPage: 'one:arhivirana stran|other:arhivirane strani',
    character: 'one:znak|other:znakov',
    runQueued: 'Čaka na začetek',
    runRunning: 'Še vedno se izvaja',
    runApproval: 'Čaka na odobritev v tem klepetu',
    runCancelled: 'Ustavljeno pred dokončanjem',
    runFinished: 'Dokončano.',
    runSavedResult: 'Rezultat je shranjen.',
    runCouldNotRead: 'Ni bilo mogoče prebrati: {sources}.',
    runScheduled: 'Načrtovano',
    runBy: 'Izvedel/-a {name}',
    testRunBy: 'Preizkus izvedel/-a {name}',
    formerMember: 'nekdanji član',
    youLower: 'vi',
    colleagueLower: 'sodelavec',
    missedTime: 'enkrat',
    missedTimes: 'krat',
    runs: 'Izvajanja',
    openRunChat: 'Odpri klepet izvajanja',
    watch: 'Spremljaj',
    cancel: 'Prekliči',
    noRuns: 'Izvajanj še ni.',
    skill: 'Veščina',
    skillPublished: 'Agent vedno uporablja objavljeno različico veščine.',
    whenRuns: 'Čas izvajanja',
    day: 'Dan',
    time: 'Čas',
    cron: 'Izraz Cron',
    notPublished: '· ni objavljeno',
    version: '· različica {version}',
    today: 'danes',
    tomorrow: 'jutri',
    yesterday: 'včeraj',
    on: 'dne',
    at: 'ob',
    underCredits: 'manj kot 0,1 kredita',
    credit: 'kredit',
    credits: 'kreditov',
    took: 'Trajalo je {duration}{used}',
    versionLabel: 'Različica {version}',
    draftRevision: 'Osnutek, revizija {version}',
    following: 'po {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'V čakalni vrsti',
    statusRunning: 'Izvaja se',
    statusApproval: 'Potrebna je odobritev',
    statusDone: 'Končano',
    statusFailed: 'Spodletelo',
    statusCancelled: 'Preklicano',
    loadingWorkspace: 'Nalaganje vašega delovnega prostora…',
    knowledgeErrorRevision_conflict: 'Ta stran se je med vašim delom spremenila.',
    knowledgeErrorSuggestion_outdated:
      'Besedilo, ki ga ta predlog spreminja, je bilo medtem urejeno. Zdaj ga lahko le zavrnete ali umaknete.',
    andUsed: 'in porabljenih {credits}',
  },
  es: {
    knowledgeErrorSuggestion_reason_required: 'Explica brevemente por qué este cambio es adecuado.',
    knowledgeErrorSuggestion_no_change: 'Esto no cambiaría la página.',
    knowledgeErrorSuggestion_markdown_required: 'Una página sugerida necesita texto.',
    knowledgeErrorCompany_publish_required:
      'Solo los editores de la empresa pueden aceptar cambios.',
    knowledgeErrorKnowledge_proposal_limit:
      'Tu empresa ya tiene 200 sugerencias pendientes de revisión. Revisa algunas antes de sugerir más.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Ya tienes 50 sugerencias pendientes de revisión. Espera a que se decidan algunas o retira algunas antes de sugerir más.',
    knowledgeErrorKnowledge_page_too_large:
      'Una página supera los 256 KB. Divídela en páginas más pequeñas.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'Una página tiene más de 2.000 encabezados. Divídela en páginas más pequeñas.',
    knowledgeErrorKnowledge_page_limit:
      'Tu empresa ha alcanzado el límite de 2.000 páginas de conocimiento.',
    knowledgeErrorKnowledge_page_archived: 'Esta página está archivada.',
    knowledgeErrorKnowledge_page_has_children:
      'Mueve o archiva primero las páginas que dependen de esta.',
    knowledgeErrorKnowledge_page_delete_children:
      'Restaura o elimina primero las páginas que dependen de esta.',
    knowledgeErrorKnowledge_page_not_archived:
      'Solo se puede restaurar o eliminar una página archivada.',
    knowledgeErrorKnowledge_root_page:
      'La página de resumen de la empresa no se puede mover ni archivar.',
    knowledgeErrorKnowledge_page_cycle:
      'Una página no se puede mover dentro de sí misma ni de ninguna de sus propias páginas.',
    knowledgeErrorKnowledge_parent_not_found: 'Esa página ya no está disponible.',
    knowledgeErrorKnowledge_parent_archived: 'Esa página está archivada. Elige otra.',
    knowledgeErrorKnowledge_page_not_found: 'Esta página ya no está disponible.',
    knowledgeErrorKnowledge_proposal_not_found: 'Esta sugerencia ya no está disponible para ti.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Solo la persona que hizo esta sugerencia puede retirarla.',
    knowledgeErrorProposal_not_pending: 'Esta sugerencia ya se ha decidido.',
    knowledgeErrorProposal_requester_removed:
      'La persona que hizo esta sugerencia ya no pertenece a esta empresa, por lo que no se puede aceptar.',
    knowledgeErrorPage_archived:
      'Esta página se archivó. Aceptar esta sugerencia la recuperaría; vuelve a revisarla primero.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva no pudo aceptar estos datos. Comprueba los campos e inténtalo de nuevo.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Las páginas de conocimiento no están disponibles en este momento. Inténtalo de nuevo.',
    knowledgeErrorKnowledge_pages_timeout:
      'Poneva tardó demasiado en responder. Inténtalo de nuevo.',
    agentErrorAgent_unpublished: 'Publica una versión antes de ejecutar este agente.',
    agentErrorAgent_revision_conflict:
      'Otra persona cambió este agente. Vuelve a cargarlo antes de guardarlo de nuevo.',
    agentErrorAgent_run_queue_full:
      'Este agente ya tiene varias ejecuciones en espera. Inténtalo de nuevo en un momento.',
    agentErrorPublished_skill_required: 'Elige una habilidad publicada que puedas usar.',
    agentErrorInvalid_schedule:
      'No se pudo leer esa programación. Comprueba la hora o la expresión cron.',
    agentErrorSchedule_too_frequent: 'Un agente puede ejecutarse como máximo cada 15 minutos.',
    agentErrorAgent_edit_access_exists: 'Ya puedes editar este agente.',
    agentErrorAgent_forbidden: 'No puedes cambiar este agente.',
    agentErrorAgent_has_no_owner:
      'Su propietario se fue, por lo que pertenece a la empresa y sigue siendo un agente de la empresa. Desactívalo o archívalo.',
    agentErrorAgent_not_found: 'Este agente ya no está disponible para ti.',
    agentErrorAgent_instructions_required: 'Dale instrucciones o fija una habilidad primero.',
    toolbarBulletedList: 'Lista con viñetas',
    toolbarNumberedList: 'Lista numerada',
    toolbarWebLink: 'Enlace web',
    agentErrorGeneric: 'No pudimos completar esta solicitud.',
    justNow: 'ahora mismo',
    editedBy: 'editado por {name}',
    imported: 'importado',
    acceptedBy: 'aceptado por {name}',
    acceptedPoneva: 'Se aceptó la sugerencia de Poneva',
    acceptedFrom: 'Se aceptó una sugerencia de {name}',
    acceptedNamed: 'Se aceptó la sugerencia de {name}',
    acceptedSuggestion: 'Se aceptó una sugerencia',
    fromMeeting: 'De la reunión',
    inYourChat: 'En tu chat',
    inNamedChat: 'En el chat de {name}',
    inAChat: 'En un chat',
    connectedAgent: 'Un agente conectado',
    connectedAgentFor: 'Agente conectado para {name}',
    repositoryImport: 'Importación de repositorio',
    importedText: 'Texto importado',
    you: 'Tú',
    colleague: 'Un compañero',
    editedPage: 'Editó la página',
    suggestedNewPage: 'Sugirió una página nueva',
    suggestedMove: 'Sugirió un cambio de ubicación',
    suggestedArchive: 'Sugirió archivar',
    saved: 'Guardado',
    noTextYet: 'Aún no hay texto',
    openSuggestion: 'one:abrir sugerencia|other:abrir sugerencias',
    suggestion: 'one:sugerencia|other:sugerencias',
    archivedPage: 'one:página archivada|other:páginas archivadas',
    character: 'one:carácter|other:caracteres',
    runQueued: 'Esperando para comenzar',
    runRunning: 'Sigue en ejecución',
    runApproval: 'Esperando una aprobación en este chat',
    runCancelled: 'Se detuvo antes de finalizar',
    runFinished: 'Finalizado.',
    runSavedResult: 'Resultado guardado.',
    runCouldNotRead: 'No se pudo leer: {sources}.',
    runScheduled: 'Programado',
    runBy: 'Ejecutado por {name}',
    testRunBy: 'Ejecución de prueba de {name}',
    formerMember: 'un antiguo miembro',
    youLower: 'tú',
    colleagueLower: 'un compañero',
    missedTime: 'vez',
    missedTimes: 'veces',
    runs: 'Ejecuciones',
    openRunChat: 'Abrir el chat de la ejecución',
    watch: 'Ver',
    cancel: 'Cancelar',
    noRuns: 'Aún no hay ejecuciones.',
    skill: 'Habilidad',
    skillPublished: 'El agente siempre usa la versión publicada de la habilidad.',
    whenRuns: 'Cuándo se ejecuta',
    day: 'Día',
    time: 'Hora',
    cron: 'Expresión cron',
    notPublished: '· no publicada',
    version: '· versión {version}',
    today: 'hoy',
    tomorrow: 'mañana',
    yesterday: 'ayer',
    on: 'el',
    at: 'a las',
    underCredits: 'menos de 0,1 créditos',
    credit: 'crédito',
    credits: 'créditos',
    took: 'Tardó {duration}{used}',
    andUsed: 'y usó {credits}',
    versionLabel: 'Versión {version}',
    draftRevision: 'El borrador, revisión {version}',
    following: 'siguiendo {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'En cola',
    statusRunning: 'En ejecución',
    statusApproval: 'Necesita aprobación',
    statusDone: 'Listo',
    statusFailed: 'Fallido',
    statusCancelled: 'Cancelado',
    loadingWorkspace: 'Cargando tu espacio de trabajo…',
    knowledgeErrorRevision_conflict: 'Esta página cambió mientras trabajabas en ella.',
    knowledgeErrorSuggestion_outdated:
      'El texto que modifica esta sugerencia se editó desde entonces. Ahora solo se puede rechazar o retirar.',
  },
  sv: {
    knowledgeErrorSuggestion_reason_required:
      'Skriv med några ord varför den här ändringen är rätt.',
    knowledgeErrorSuggestion_no_change: 'Det här skulle inte ändra sidan.',
    knowledgeErrorSuggestion_markdown_required: 'En föreslagen ny sida behöver innehålla text.',
    knowledgeErrorCompany_publish_required: 'Endast företagspublicerare kan godkänna ändringar.',
    knowledgeErrorKnowledge_proposal_limit:
      'Ditt företag har redan 200 förslag som väntar på granskning. Granska några innan du föreslår fler.',
    knowledgeErrorKnowledge_proposal_author_limit:
      'Du har redan 50 förslag som väntar på granskning. Vänta tills några har beslutats eller återkalla några innan du föreslår fler.',
    knowledgeErrorKnowledge_page_too_large:
      'En sida är större än 256 KB. Dela upp den i mindre sidor.',
    knowledgeErrorKnowledge_page_too_many_sections:
      'En sida har fler än 2 000 rubriker. Dela upp den i mindre sidor.',
    knowledgeErrorKnowledge_page_limit: 'Ditt företag har nått gränsen på 2 000 kunskapssidor.',
    knowledgeErrorKnowledge_page_archived: 'Den här sidan är arkiverad.',
    knowledgeErrorKnowledge_page_has_children: 'Flytta eller arkivera sidorna under den här först.',
    knowledgeErrorKnowledge_page_delete_children:
      'Återställ eller ta bort sidorna under den här först.',
    knowledgeErrorKnowledge_page_not_archived:
      'Endast en arkiverad sida kan återställas eller tas bort.',
    knowledgeErrorKnowledge_root_page: 'Företagets översiktssida kan inte flyttas eller arkiveras.',
    knowledgeErrorKnowledge_page_cycle:
      'En sida kan inte flyttas under sig själv eller någon av sina egna sidor.',
    knowledgeErrorKnowledge_parent_not_found: 'Den sidan är inte längre tillgänglig.',
    knowledgeErrorKnowledge_parent_archived: 'Den sidan är arkiverad. Välj en annan.',
    knowledgeErrorKnowledge_page_not_found: 'Den här sidan är inte längre tillgänglig.',
    knowledgeErrorKnowledge_proposal_not_found:
      'Det här förslaget är inte längre tillgängligt för dig.',
    knowledgeErrorKnowledge_proposal_forbidden:
      'Endast personen som föreslog detta kan återkalla det.',
    knowledgeErrorProposal_not_pending: 'Det här förslaget har redan avgjorts.',
    knowledgeErrorProposal_requester_removed:
      'Personen som föreslog detta finns inte längre i företaget, så det kan inte godkännas.',
    knowledgeErrorPage_archived:
      'Den här sidan arkiverades. Om du godkänner förslaget återställs den; granska det igen först.',
    knowledgeErrorInvalid_knowledge_page_input:
      'Poneva kunde inte godkänna den här inmatningen. Kontrollera fälten och försök igen.',
    knowledgeErrorKnowledge_pages_unavailable:
      'Kunskapssidor är inte tillgängliga just nu. Försök igen.',
    knowledgeErrorKnowledge_pages_timeout: 'Poneva tog för lång tid på sig att svara. Försök igen.',
    agentErrorAgent_unpublished: 'Publicera en version innan du kör den här agenten.',
    agentErrorAgent_revision_conflict:
      'Någon annan ändrade den här agenten. Läs in den igen innan du sparar.',
    agentErrorAgent_run_queue_full:
      'Den här agenten har redan flera körningar som väntar. Försök igen om en stund.',
    agentErrorPublished_skill_required: 'Välj en publicerad färdighet som du kan använda.',
    agentErrorInvalid_schedule:
      'Det gick inte att läsa schemat. Kontrollera tiden eller cron-uttrycket.',
    agentErrorSchedule_too_frequent: 'En agent kan köras högst var 15:e minut.',
    agentErrorAgent_edit_access_exists: 'Du kan redan redigera den här agenten.',
    agentErrorAgent_forbidden: 'Du kan inte ändra den här agenten.',
    agentErrorAgent_has_no_owner:
      'Dess ägare har slutat, så den tillhör företaget och förblir en företagsagent. Stäng av eller arkivera den i stället.',
    agentErrorAgent_not_found: 'Den här agenten är inte längre tillgänglig för dig.',
    agentErrorAgent_instructions_required: 'Ge den instruktioner eller fäst en färdighet först.',
    toolbarBulletedList: 'Punktlista',
    toolbarNumberedList: 'Numrerad lista',
    toolbarWebLink: 'Webblänk',
    agentErrorGeneric: 'Vi kunde inte slutföra den här begäran.',
    justNow: 'just nu',
    editedBy: 'redigerat av {name}',
    imported: 'importerat',
    acceptedBy: 'accepterat av {name}',
    acceptedPoneva: 'Accepterade Ponevas förslag',
    acceptedFrom: 'Accepterade ett förslag från {name}',
    acceptedNamed: 'Accepterade {name}s förslag',
    acceptedSuggestion: 'Accepterade ett förslag',
    fromMeeting: 'Från mötet',
    inYourChat: 'I din chatt',
    inNamedChat: 'I {name}s chatt',
    inAChat: 'I en chatt',
    connectedAgent: 'En ansluten agent',
    connectedAgentFor: 'Ansluten agent för {name}',
    repositoryImport: 'Import av kodförråd',
    importedText: 'Importerad text',
    you: 'Du',
    colleague: 'En kollega',
    editedPage: 'Redigerade sidan',
    suggestedNewPage: 'Föreslog en ny sida',
    suggestedMove: 'Föreslog en flytt',
    suggestedArchive: 'Föreslog arkivering',
    saved: 'Sparat',
    noTextYet: 'Ingen text ännu',
    openSuggestion: 'one:öppet förslag|other:öppna förslag',
    suggestion: 'one:förslag|other:förslag',
    archivedPage: 'one:arkiverad sida|other:arkiverade sidor',
    character: 'one:tecken|other:tecken',
    runQueued: 'Väntar på att starta',
    runRunning: 'Körs fortfarande',
    runApproval: 'Väntar på ett godkännande i den här chatten',
    runCancelled: 'Avbröts innan den blev klar',
    runFinished: 'Slutförd.',
    runSavedResult: 'Resultat sparat.',
    runCouldNotRead: 'Kunde inte läsa: {sources}.',
    runScheduled: 'Schemalagd',
    runBy: 'Kördes av {name}',
    testRunBy: 'Testkörning av {name}',
    formerMember: 'en tidigare medlem',
    youLower: 'du',
    colleagueLower: 'en kollega',
    missedTime: 'gång',
    missedTimes: 'gånger',
    runs: 'Körningar',
    openRunChat: 'Öppna körningschatten',
    watch: 'Visa',
    cancel: 'Avbryt',
    noRuns: 'Inga körningar ännu.',
    skill: 'Färdighet',
    skillPublished: 'Agenten använder alltid den publicerade versionen av färdigheten.',
    whenRuns: 'När den körs',
    day: 'Dag',
    time: 'Tid',
    cron: 'Cron-uttryck',
    notPublished: '· inte publicerad',
    version: '· version {version}',
    today: 'idag',
    tomorrow: 'imorgon',
    yesterday: 'igår',
    on: 'den',
    at: 'kl.',
    underCredits: 'under 0,1 krediter',
    credit: 'kredit',
    credits: 'krediter',
    took: 'Tog {duration}{used}',
    andUsed: 'och använde {credits}',
    versionLabel: 'Version {version}',
    draftRevision: 'Utkast, revision {version}',
    following: 'följer {skills}',
    timeSecond: 's',
    timeMinute: 'min',
    timeHour: 'h',
    statusQueued: 'Köad',
    statusRunning: 'Körs',
    statusApproval: 'Kräver godkännande',
    statusDone: 'Klar',
    statusFailed: 'Misslyckad',
    statusCancelled: 'Avbruten',
    loadingWorkspace: 'Läser in din arbetsyta…',
    knowledgeErrorRevision_conflict: 'Den här sidan ändrades medan du arbetade med den.',
    knowledgeErrorSuggestion_outdated:
      'Texten som förslaget ändrar har redigerats sedan dess. Det går nu bara att avvisa eller dra tillbaka förslaget.',
  },
} as const;

export default workspaceKnowledgeRuntimeCopy satisfies NamespaceCatalog<
  keyof typeof workspaceKnowledgeRuntimeCopy.en
>;
